webpackJsonp([32],{

/***/ "+BXW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        value: String,
        name: String,
        validate: {
            type: [String, Object],
            default: ""
        },
        placeholder: String,
        type: {
            type: String,
            default: "text"
        },
        alias: {
            type: String,
            default: null
        },
        disabled: {
            type: [Boolean, Object],
            default: false
        }
    },
    inject: ['$validator'],
    methods: {
        updateValue: function updateValue(val) {
            this.$emit('input', val);
        }
    }
});

/***/ }),

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__("/Put");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("50Yw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+jXL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_panel_vue__ = __webpack_require__("Ys3e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8aa22cf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_panel_vue__ = __webpack_require__("5GNo");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_panel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8aa22cf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+yMS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dist_i18n_da_json__ = __webpack_require__("2uvg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dist_i18n_da_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__dist_i18n_da_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dist_i18n_en_json__ = __webpack_require__("PZJq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dist_i18n_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__dist_i18n_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dist_i18n_de_json__ = __webpack_require__("Z53w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dist_i18n_de_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__dist_i18n_de_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_polyglot__ = __webpack_require__("LZJx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_polyglot__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_polyglot___default.a, {
    defaultLanguage: 'da',
    languagesAvailable: ['en', 'da', 'de']
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].locales({
    "da": __WEBPACK_IMPORTED_MODULE_2__dist_i18n_da_json___default.a,
    "en": __WEBPACK_IMPORTED_MODULE_3__dist_i18n_en_json___default.a,
    "de": __WEBPACK_IMPORTED_MODULE_4__dist_i18n_de_json___default.a
});

/***/ }),

/***/ "/Iwc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logout; });
var logout = function logout(_ref) {
    var commit = _ref.commit;

    commit("clearContext");
    commit("logout");
};

/***/ }),

/***/ "/Put":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__("fnDg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),

/***/ "022v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        label: {
            type: String
        },
        left: {
            type: Boolean,
            default: false
        },
        fullWidth: {
            type: Boolean,
            default: false
        }
    }
});

/***/ }),

/***/ "0EFW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0GqW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language-switcher flags"},_vm._l((_vm.languages),function(lang){return _c('a',{key:lang,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.setLanguage(lang)}}},[_c('img',{attrs:{"src":_vm.flag(lang)}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1g66":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1wrJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2uvg":
/***/ (function(module, exports) {

module.exports = {"login.btn_create_account":"Opret ny konto","login.btn_login":"Log ind","login.btn_reset_pwd":"Glemt adgangskode","login.create.title":"Opret konto","login.create.desc":"For at kunne bruge kontrolpanelet, bør du have købt en SensorCLIP enhed. Du kan altid oprette dig her og tilføje enheden senere.","login.create.confirm_back":"Er du sikker på du vil stoppe og gå tilbage?","login.create.email_in_use":"Den angivne e-mail er allerede registreret i vores systemer.","login.create.generic_error":"Din bruger kunne ikke oprettes. Gennemse dine oplysninger herunder eller kontakt vores support.","login.forgotten.title":"Glemt din adgangskode?","login.forgotten.desc":"Kontakt vores support for at få hjælp til at få adgang til din konto. Du finder vores kontaktoplysninger via linket herunder:","msg.error":"Der opstod en fejl, og den ønskede handling kunne ikke fuldføres","msg.error_loading":"Kunne ikke hente informationen","msg.error_loading_units_with_pending_updates":"Kunne ikke hente listen over enheder, som afventer opdatering","customer":"Kunde","customers":"Kunder","alarm":"Alarm","alarms":"Alarmer","unit":"Afdeling","units":"Afdelinger","processing":"Arbejder...","loading":"Indlæser...","label.email":"E-mail","label.email_billing":"E-mail til fakturering","label.sms":"SMS","label.name":"Navn","label.phone":"Telefon","label.password":"Adgangskode","label.actions":"Handlinger","label.time":"Tid","label.message":"Besked","label.comment":"Kommentar","label.serial":"Serienr","label.subscription":"Abonnement","label.user":"Bruger","label.type":"Type","label.sensorunit":"Enhed","label.pin":"PIN","label.imei":"IMEI","label.iccid":"ICCID","label.hardware":"Hardware model","label.firmware":"Firmware version","label.signal":"Signalstyrke","label.battery":"Batteri","label.expires":"Abonnementsudløb","expires.never":"Aldrig","expires.already_expired":"Udløbet","label.sensor_internal":"Intern","label.sensor_external":"Ekstern","label.sensor":"Sensor","label.password_repeat":"Gentag adgangskode","label.new_password":"Ny adgangskode","label.permissions":"Rettigheder","label.receiver":"Modtager","label.cvr":"CVR","label.address1":"Adresse 1","label.address2":"Adresse 2","label.address3":"Kontaktperson","label.zipcode":"Postnr.","label.city":"By","label.country":"Land","label.choose_checkbox":"Vælg","label.firmware_file":"Fil med firmware","btn_change_password":"Skift adgangskode","btn_delete_profile":"Slet konto","btn_back":"Tilbage","btn_edit":"Rediger","btn_save":"Gem","btn_remove":"Fjern","btn_delete":"Slet","btn_cancel":"Annuller","btn_print":"Print","btn_next":"Næste","btn_prev":"Forrige","btn_reset":"Nulstil","btn_close":"Luk","btn_yes":"Ja","btn_no":"Nej","monday":"Mandag","tuesday":"Tirsdag","wednesday":"Onsdag","thursday":"Torsdag","friday":"Fredag","saturday":"Lørdag","sunday":"Søndag","menu.overview":"Oversigt","menu.create_account":"Opret konto","menu.assign_account":"Tilknyt konto","menu.detach_account":"Fjern konto","menu.add_unit":"Opret enhed","menu.fleetmap":"Kort","menu.alarms":"Alarmer","menu.alerting":"Alarmering","menu.alerting_add":"Tilføj ny","menu.report":"Rapport","menu.permissions":"Rettigheder","menu.contacts":"Kontaktpersoner","menu.contacts_add":"Tilføj ny","menu.comments":"Kommentarer","menu.profile":"Profil","menu.profile_delete":"Slet profil","menu.units":"Enheder","menu.back_dashboard":"Tilbage til oversigt","menu.back_contacts":"Tilbage til kontaktpersoner","menu.back_alerting":"Tilbage til alarmering","topmenu.activity":"Aktivitet","topmenu.search":"Søg","topmenu.api":"API","topmenu.customer_units":"Kundens enheder","topmenu.requisitions":"Nye enheder","topmenu.my_units":"Mine enheder","topmenu.my_profile":"Min profil","topmenu.logout":"Log ud","topmenu.firmware_update":"Opdater firmware","topmenu.firmware":"Firmware","dashboard.fetch_more":"Hent flere","dashboard.alarm":"alarm","dashboard.alarms":"alarmer","dashboard.error_fetching_active":"Der opstod en fejl i forsøget på at hente antallet af aktive alarmer","dashboard.error_fetching_user":"Kunne ikke hente information om den angivne bruger","dashboard.filter.customer_label":"Søg efter kunde eller enhed","dashboard.filter.customer_placeholder":"Navn, adresse, serienummer","dashboard.filter.unit_label":"Søg efter afdeling eller enhed","dashboard.filter.unit_placeholder":"Navn, adresse, serienummer","dashboard.filter.device_label":"Søg efter enhed","dashboard.filter.device_placeholder":"Navn eller serienummer","dashboard.filter.zoom_label":"Zoom","dashboard.filter.zoom_placeholder":"Zoom","dashboard.no_units_yet":"Du har endnu ikke tilknyttet nogle enheder. Klik på knappen 'Opret Enhed' ovenfor, for at komme igang.","dashboard.title.my_units":"Mine enheder","sensor.last_connected":"Sidst forbundet","sensor.add_subscription":"Tilknyt abonnement","sensor.deactivated":"Denne sensor er deaktiveret, da den ikke har et aktivt abonnement.","sensor.btn_remove_deactivated":"Fjern fra konto","sensor.msg_confirm_remove_deactivated":"Vil du virkelig fjerne denne enhed fra din konto?","sensor.tab.general":"Generelt","sensor.tab.settings":"Indstillinger","sensor.tab.receivers":"Alarmmodtagere","sensor.tab.alarms":"Alarmer","sensor.tab.location":"Lokation","sensor.tab.logs":"Målinger","sensor.tab.service":"Service","sensor.tab.rules":"Alarm regler","sensor.tab.comments":"Kommentarer","sensor.tab.images":"Uploads","sensor.tab.subscription":"Abonnement","sensor.general.btn_subscribe_extend":"Forlæng","sensor.general.btn_unsubscribe":"Fjern","sensor.general.confirm_unsubscribe":"Hvis du opsiger denne enhed, slettes den og al historik fra din konto. Denne handling kan ikke fortrydes. \n\nVil du fortsætte sletningen?","sensor.general.msg_unsubscribed":"Enheden blev fjernet fra din konto","sensor.contacts.none":"Der er endnu ikke nogen alarmmodtagere tilknyttet. Der er med andre ord ingen, der får besked, såfremt sensoren går i alarm.","sensor.contacts.btn_add":"Ny alarmmodtager","sensor.contacts.btn_assign":"Tilknyt alarmmodtager","sensor.contacts.confirm_removal":"Vil du virkelig fjerne denne modtager?","sensor.rules.desc":"Du kan deaktivere notifikationer i specifikke tidsrum. Er der opstået en alarm i et af de angivne tidsrum, vil du aldrig få besked om det - heller ikke hvis det fortsætter udover den angivne periode. Du vil modtage alarmer så længe sms eller e-mail er sat til 'Off'.","sensor.rules.warning_desc":"Denne menu skal KUN benyttes hvis du IKKE ønsker at modtage sms/e-mail i valgte perioder.","sensor.rules.btn_update":"Opdater regler","sensor.rules.deactivate":"Deaktivering af notifikationer","sensor.rules.from":"Fra klokken","sensor.rules.to":"Til klokken","sensor.rules.updated":"Reglerne blev opdateret","sensor.rules.failed":"Reglerne kunne ikke opdateres","sensor.rules.validation_time_invalid":"Start kan ikke være efter sluttidspunkt","sensor.alarms.in_alarm":"Denne enhed er i alarm!","sensor.alarms.none":"Der er ingen alarmer at vise.","sensor.alarms.fetch":"Hent data","sensor.alarms.comment.headline":"Kommentar til alarmen ","sensor.alarms.comment.confirm_delete":"Vil du virkelig slette kommentaren?","sensor.alarms.comment.delete_failed":"Kunne ikke slette kommentaren","sensor.alarms.comment.edit_failed":"Kunne ikke ændre kommentaren","sensor.alarms.acknowledge_failed":"Kunne ikke kvitterer for alarmen","sensor.alarms.acknowledged":"Kvitterede for alarm. Den vil være skjult for fremtiden.","sensor.rules.sms_col":"Deaktiver SMS","sensor.rules.email_col":"Deaktiver E-mail","sensor.comments.none_yet":"Der er ingen kommentarer til denne sensor endnu.","sensor.comments.no_input":"Angiv venligst en kommentar","sensor.comments.confirm_delete":"Vil du virkelig slette kommentaren?","sensor.comments.deleted":"Kommentaren blev slettet","sensor.comments.updated":"Kommentaren blev gemt","sensor.comments.updated_failed":"Kommentaren kunne ikke gemmes","sensor.location.unknown":"Positionen af denne enhed er ikke kendt.","btn_save_comment":"Gem kommentar","sensor.log.none_selected":"Der findes ingen aktuelle måledata for denne sensor i den valgte periode","sensor.log.temperature_1":"Temperatur 1","sensor.log.temperature_2":"Temperatur 2","sensor.log.temperature":"Temperatur","sensor.log.wellguard.on_time":"Kørselstid i / Runtime [min]","sensor.log.wellguard.max_on_time":"Maksimal kørselstid / Max Runtime [min]","sensor.log.wellguard.on_count":"Antal kørsler / Count","sensor.log.wellguard.usage":"Forbrug i kWh","sensor.log.wellguard.summary.on_time":"Samlet kørselstid [timer]","sensor.log.wellguard.summary.max_on_time":"Maksimal kørselstid i perioden [min]","sensor.log.wellguard.summary.on_count":"Samlet antal kørsler","sensor.log.wellguard.summary.usage":"Samlet forbrug [kWh]","sensor.log.fenceguard.voltage":"Volt","sensor.log.summary.period":"Summeret data ud fra den valgte periode","sensor.log.summary.entries":"Individuelle registreringer i perioden","sensor.log.summery.date_to":"til","sensor.images.choose_image":"Tilføj billede eller PDF","sensor.images.uploaded":"Filen blev gemt","sensor.images.deleted":"Filen blev slettet","sensor.image.popup.btn_delete":"Slet","sensor.image.popup.btn_download":"Download","sensor.image.popup.btn_close":"Luk vindue","sensor.image.popup.confirm_delete":"Er du sikker på, at du vil slette dette billede permanent?","sensor.settings.sensor_1":"Sensor 1","sensor.settings.sensor_2":"Sensor 2","sensor.settings.temperature_limits":"Grænser for temperatur","sensor.settings.alarm_delay":"Alarm delay for temperatur","sensor.settings.calibration":"Kalibrering","sensor.settings.max_runtime":"Max runtime","sensor.settings.max_runtime_delay":"Max runtime delay","sensor.settings.power_off_delay":"Power off alarm delay","sensor.settings.voltage_limit":"Alarm grænse for strøm","sensor.settings.power_limits":"Driftsområde","sensor.settings.power_limits_delay":"Alarm Delay Driftsområde","sensor.settings.power_max_idle":"Maksimal tid for dvale (strøm)","sensor.settings.hibernate_max_power":"Maksimal strømforbrug i dvale","sensor.settings.digital_input_delay":"Alarm Delay kontaktsæt","sensor.settings.digital_input_enabled":"Brug digitalt kontaktsæt","sensor.settings.pulse_input":"Benyt indgang som kontaktsæt","sensor.settings.pulse_input.off":"Slået fra","sensor.settings.pulse_input.normally_closed":"Alarm hvis afbrudt (Normal Closed)","sensor.settings.pulse_input.normally_open":"Alarm hvis forbundet/kortsluttet (Normal Open)","sensor.settings.time_sync":"Tidspunkt for synkronisering","sensor.settings.wakeups":"Wakeups pr. uge","sensor.settings.voltage":"Volt","sensor.settings.reminder":"Genudsend alarm","sensor.settings.resync":"Synkroniser efter alarm","sensor.settings.service_interval":"Interval for service (timer)","sensor.settings.servicekit_interval":"Interval for servicekit (timer)","sensor.settings.service_notification_enabled":"Send notifikation ved tid til service","sensor.settings.service_notification_email":"E-mail til notifikation (service)","sensor.settings.servicekit_notification_email":"E-mail til notifikation (servicekit)","sensor.settings.service_notification_email.placeholder":"Indtast mail-adresser adskilt af mellemrum, komma eller semikolon","sensor.settings.tip_seconds":"sek","sensor.settings.tip_min":"min","sensor.settings.tip_hour":"time","sensor.settings.tip_hours":"timer","sensor.settings.btn_save":"Gem indstillinger","sensor.settings.saved":"Indstillingerne blev gemt","sensor.settings.save_failed":"Indstillingerne kunne ikke gemmes","sensor.settings.heading_service":"Service","sensor.toggle.pulse_input_settings":"Aktiver kontaktsæt","sensor.graphs.select_date":"Vælg dato","sensor.graphs.change_date":"Opdater graf","sensor.graphs.no_data":"Ingen data i interval","sensor.graphs.refresh":"Opdater graf","sensor.graphs.label_measured_temperature":"Målt temperatur","sensor.graphs.label_measured_at":"Måling foretaget","sensor.graphs.axis_temperature":"Temperatur °C","sensor.graphs.label_measured_usage":"Målt forbrug","sensor.graphs.label_measured_voltage":"Volt","sensor.graphs.label_measured_value":"Målt værdi","sensor.graphs.axis_usage":"Forbrug i kWh","sensor.graphs.axis_voltage":"kWh","sensor.graphs.legends.operation_info":"Operations Info","calendar.months_full":"Januar_Februar_Marts_April_Maj_Juni_Juli_August_September_Oktober_November_December","calendar.months_short":"Jan_Feb_Mar_Apr_Maj_Jun_Jul_Aug_Sep_Okt_Nov_Dec","calendar.weekdays":"Man_Tir_Ons_Tor_Fre_Løn_Søn","label.filtering":"Filtrering","label.filter.sensor":"Vælg enhed:","label.filter.period":"Vælg periode:","label.filter.date":"Vælg dato","alarms.active":"Aktive alarmer","alarms.previous":"Tidligere alarmer","alarms.search_results":"Filtrerede alarmer","alarms.no_active":"Der er i øjeblikket ingen aktive alarmer.","alarms.no_search":"Der er ingen alarmer med den valgte filtrering.","alarms.failed_fetching_active":"Kunne ikke hente data fra serveren om aktive alarmer","alarms.failed_fetching_search":"Kunne ikke hente data fra serveren","alarms.btn_print":"Print","alarms.btn_export_csv":"Eksporter til CSV","alarms.btn_acknowledge":"Kvittér og fjern alarm","select_all":"- Alle -","select_units_choose_all":"Vælg alle","select_units_not_chosen":"Fravalgte enheder","select_units_chosen":"Valgte enheder","select_error_fetching_units":"Der opstod en fejl og listen over enheder kunne ikke hentes","report.title":"Temperaturrapport","report.btn_fetch":"Hent data","report.btn_print":"Print","report.comment":"Kommentar","report.no_alarms":"Ingen alarmer.","report.choose_least_one":"Vælg venligst mindst én sensor","report.could_not_fetch_for_sensor":"Kunne ikke hente måledata for sensor","contacts.none":"Der er endnu ikke oprettet nogle kontaktpersoner.","contacts.title":"Kontaktpersoner","contacts.title_edit":"Rediger kontaktperson","contacts.sensor2.subtitle":"Til brug for ekstra sensor","contacts.sensor2.desc":"Visse enheder kan have flere sensorer indbyggede, som du kan tilknytte separate kontaktpersoner til. Kontaktpersonerne vil kun være synlige for brugere, der også kan se sensor 2.","contacts.confirm_delete":"Vil du virkelig slette denne kontakt?","btn_save_information":"Gem oplysninger","contacts.deleted":"Kontaktpersonen blev slettet","contacts.saved":"Oplysningerne blev gemt","contacts.wizard.title_basic":"Gundlæggende information","contacts.wizard.title_units":"Modtag alarmer fra enheder","contacts.wizard.menu_info":"Kontaktperson","contacts.wizard.menu_units":"Alarmer","contacts.wizard.units_desc":"Angiv herunder de enheder, som personen skal modtage alarmer fra. Dette kan også gøres senere på siden med de enkelte enheder.","contacts.title_assign":"Tilknyt alarmmodtager","contacts.btn_assign_units":"Tilknyt til enheder","contacts.btn_assign":"Tilknyt","contacts.btn_create":"Opret kontaktperson","contacts.link_create":"Opret","contacts.assigned":"Alarmmodtageren blev tilknyttet enheden","contacts.unassigned":"Alarmmodtageren blev fjernet fra enheden","contacts.popup.choice_sensor1":"Sensor 1 (standard)","contacts.popup.choice_sensor2":"Sensor 2","contacts.create.success":"Kontaktpersonen blev oprettet","contacts.create.success_with_units":"Kontaktpersonen blev oprettet og tilføjet til enhederne","contacts.create.failed_with_units":"Kontaktpersonen blev oprettet, men kunne ikke tilføjes til enhederne","alerting.title":"Alarmering","alerting.title_edit":"Rediger kontakt for alarmering","alerting.description":"Kontakter herunder vil blive alarmeret, såfremt der er en alarm i en hos en vilkårlig underkonto.","alerting.none":"Der er endnu ikke nogen kontakter defineret på dette niveau.","alerting.btn_add":"Ny kontakt","alerting.btn_activate":"Aktiver","alerting.btn_deactivate":"Deaktiver","alerting.confirm_delete":"Vil du virkelig fjerne denne modtager permanent?","alerting.lbl_active":"Aktiv","alerting.enabled":"Kontakten vil nu modtage alarmer","alerting.disabled":"Kontakten vil ikke længere modtage alarmer","alerting.deleted":"Kontaktpersonen blev fjernet","alerting.saved":"Oplysningerne blev gemt","alerting.confirm_disable":"Ønsker du at deaktivere alarmer for kontaktpersonen midlertidigt?","alerting.name_invalid":"Angiv venligst et navn","alerting.yes":"Ja","alerting.no":"Nej","profile.chose_country":"- Vælg venligst -","profile.saved":"Oplysningerne blev gemt","profile.pwd_saved":"Adgangskoden blev skiftet","profile.title":"Profil for","profile.title_change_your_pwd":"Skift din adgangskode","profile.title_change_other_pwd":"Skift adgangskode for","profile.title_delete":"Slet konto","profile.warn_delete_desc":"Du er ved at slette din konto. Alle sensorer og tilhørende data vil blive slettet. Oplysninger om din profil vil blive gemt i henhold til Regnskabsloven. Processen er ikke mulig at fortryde.","profile.confirm_deletion_before_account_name":"Ønsker du at slette alt data vedrørende konto ","profile.confirm_deletion_after_account_name":"?","profile.msg_sensors_exists":"Opsig venligst alle enheder førend du sletter din profil","profile.deleted":"Kontoen blev slettet","country.belgium":"Belgien","country.bulgaria":"Bulgarien","country.cyprus":"Cypern","country.denmark":"Danmark","country.farao_islands":"Færøerne","country.greenland":"Grønland","country.estonia":"Estland","country.finland":"Finland","country.france":"Frankrig","country.greece":"Grækenland","country.ireland":"Irland","country.island":"Island","country.italy":"Italien","country.latvia":"Letland","country.lithuania":"Litauen","country.luxembourg":"Luxembourg","country.malta":"Malta","country.netherlands":"Nederlandene","country.norway":"Norge","country.poland":"Polen","country.portugal":"Portugal","country.romania":"Rumænien","country.switzerland":"Schweiz","country.slovakia":"Slovakiet","country.slovenia":"Slovenien","country.spain":"Spanien","country.united_kingdom":"Storbritannien","country.sweden":"Sverige","country.czech_republic":"Tjekkiet","country.germany":"Tyskland","country.hungary":"Ungarn","country.usa":"USA","country.austria":"Østrig","country.canada":"Canada","country.tunisia":"Tunesien","users.wizard.title_account":"Konto","users.wizard.title_basic":"Grundlæggende information","users.wizard.title_permissions":"Rettigheder","users.wizard.full_access":"Dette giver brugeren fuld adgang til alle enheder og konti","users.wizard.tier1_user":"Administrator (forbeholdt SensorCLIP)","users.wizard.tier2_user":"Super bruger","users.wizard.tier3_user":"Almindelig bruger","users.wizard.tier3_assigned":"tilknyttet","users.wizard.msg_created":"Brugeren blev oprettet","users.wizard.msg_failed":"Brugeren kunne ikke oprettes","users.wizard.msg_email_used":"Den angivne e-mail er allerede i brug","warning":"ADVARSEL","permissions.title":"Brugerens rettigheder","permissions.only_edit_new":"Det er kun muligt at redigere denne indstilling ved oprettelse af nye brugere.","permissions.sensor_view_extra":"Kan se ekstra sensor på understøttede enheder","permissions.user_manage_everybody":"Kan se alle brugerkonti uanset ejer","permissions.user_manage_children":"Kan se underkonti","permissions.sensor_edit":"Kan konfigurere sensorer","permissions.comment_manage":"Kan se og tilføje kommentarer for andre brugere","permissions.service_edit":"Kan se fanen Service og gennemføre inspektioner","permissions.payment":"Betalingsmetode","permissions.payment_card":"Kortbetaling","permissions.payment_invoice":"Faktura","permissions.payment_requisition":"Rekvisition","permissions.payment_none":"Admin (ingen betaling)","permissions.monitor_view":"Logges ikke ud ved visning af sensoroversigten","permissions.msg_updated":"Brugerens rettigheder blev opdateret","permissions.msg_failed":"Tilladelserne til brugeren kunne ikke opdateres!","login.attach.title":"Tilknyt underkonto","login.attach.desc":"Her kan du tilføje en underkonto til din egen bruger. Dette giver dig permanent adgang over kontoen og dens enheder. For at verificere tilknytningen skal du logge på med den anden kontos oplysninger.","login.attach.btn_assign":"Tilknyt","login.attach.msg_error_use_subaccount_email":"Dette skal være underkontoens e-mail - ikke din egen","login.attach.msg_assigned":"Kontoen er nu blevet registreret som en underkonto","login.attach.msg_error":"Der opstod en fejl og underkontoen kunne ikke tilknyttes","login.attach.msg_wrong_credentials":"Brugernavn eller adgangskode for underkontoen er forkert","login.attach.msg_already_access":"Du har allerede adgang til den valgte underkonto","login.detach.title":"Fjern adgang til underkonto","login.detach.desc":"Her kan du fjerne adgangen til en tilknyttet underkonto. Dette betyder at du ikke længere vil kunne tilgå eller ændre underkontoen eller dens sensorer. Du kan dog altid tilknytte underkontoen igen for at opnå adgang påny. Alle sensorer og indstillinger på underkontoen vil forblive, som de er nu.","login.detach.msg_error":"Kunne ikke fjerne adgangen til underkonto","login.detach.msg_success":"Adgangen til underkontoen er nu fjernet","login.detach.btn_detach":"Fjern","activity.title":"Aktivitetslog","activity.action":"Udført handling","activity.subject":"Reference","activity.author":"Foretaget af","activity.btn_details":"Detaljer","activity.change_key":"Værdi","activity.change_old":"Tidligere","activity.change_new":"Ny","configure.wizard.contacts.menu_sensors":"Enheder","configure.wizard.contacts.menu_contacts":"Alarmmodtagere","configure.wizard.contacts.title":"Tilknyt alarmmodtagere til flere enheder","configure.wizard.contacts.title_contacts":"Vælg alarmmodtagere","configure.wizard.contacts.desc":"Herunder har du mulighed for at tilknytte alarmmodtagere til flere enheder på samme tid. Det vil ikke fjerne de eksisterende alarmmodtagere på enhederne, men kun tilføje eventuelle nye alarmmodtagere til de valgte enheder.","configure.wizard.contacts.desc_contacts_double":"Du har her mulighed for at tilknytte alarmmodtagere til både sensor 1 og sensor 2 for hver enkelt enhed, såfremt enheden understøtter det. Bemærk at du ikke kan fjerne alarmmodtagere herunder, men udelukkende tilknytte ekstra alarmmodtagere.","configure.wizard.contacts.desc_contacts":"De valgte enheder vil få tilknyttet alle de alarmmodtagere, du vælger herunder, i tillæg til eventuelle eksisterende alarmmodtagere.","configure.wizard.contacts.sensor1":"Sensor 1","configure.wizard.contacts.sensor2":"Sensor 2","configure.wizard.contacts.validation_need_sensor":"Vælg venligst mindst én enhed","configure.wizard.contacts.validation_need_contact":"Vælg venligst mindst én alarmmodtager","configure.wizard.contacts.working_desc":"Gemmer dine alarmmodtagere på enhederne. Du kan følge med i processen herunder.","configure.wizard.contacts.msg_error_specific_contact":"Det var ikke muligt at registreres som alarmmodtager for kontakten ","configure.wizard.contacts.msg_success_some":"En eller flere alarmmodtagere blev registreret","configure.wizard.contacts.msg_success_all":"De valgte alarmmodtagere blev registreret","menu.conf_contacts":"Tilknyt alarmmodtagere","activate.title_new":"Tilføj enhed","activate.title_assigned":"Aktiver enhed","activate.btn_save":"Gem oplysninger","activate.label_requisition":"Rekvisitionsnr.","activate.label_user":"Tilknyt bruger","activate.no_action":"Vælg et abonnement, hvis du ønsker at aktivere enheden","activate.msg_attached":"Enheden blev tilknyttet til brugeren","activate.msg_activated":"Enheden er nu aktiveret","activate.msg_failed_activate":"Kunne ikke aktivere enheden","activate.wizard.tab_unit":"Enhed","activate.wizard.tab_subscription":"Abonnement","activate.wizard.tab_terms":"Handelsbetingelser","activate.wizard.tab_payment":"Betaling","activate.wizard.title_info":"Oplysninger om enheden","activate.wizard.title_subscription":"Vælg abonnement","activate.wizard.desc_subscription":"Vi tilbyder kun den fulde løsning og det eneste du behøver at bekymre dig om, er, hvor længe du ønsker at købe abonnement for. Du kan læse mere om <a href='http://sensorclip.dk/simkort' target='_blank' class='highlight-link'>hvad abonnementet indeholder her</a>. Alle priser er inklusiv moms.","activate.wizard.btn_approve_terms":"Godkend handelsbetingelser","activate.wizard.price_ex_vat":"Pris total ekskl. moms DKK","activate.wizard.price_in_vat":"Pris total inkl. moms DKK","activate.wizard.vat_dkk":"Moms (25%) DKK","activate.wizard.terms":"Handelsbetingelser","activate.wizard.terms_read_accepted":"Jeg har læst og accepterer","activate.wizard.terms_accepted_link":"handelsbetingelserne","activate.wizard.error_terms_required":"Handelsbetingelserne skal accepteres","activate.wizard.title_payment":"Betaling","activate.wizard.desc_payment_invoice":"Betaling foregår via faktura. Lige så snart du klikker på \"Bekræft køb\"-knappen herunder, vil enheden blive aktiveret og en faktura sendes til","activate.wizard.desc_payment_card":"Du vil nu blive sendt videre til vores betalingsside. Når betalingen er gennemført vil enheden automatisk blive aktiveret, og du vil modtage en e-mail med kvitteringen.","activate.wizard.choice.later":"Opsæt abonnement senere","activate.wizard.choice.1month":"1 måned til 59 kr","activate.wizard.choice.3months":"3 måneder til 169 kr, 5% rabat","activate.wizard.choice.6months":"6 måneder til 321 kr, 10% rabat","activate.wizard.choice.12months":"12 måneder til 570 kr, 20% rabat","activate.wizard.choice.24months":"24 måneder til 998 kr, 30% rabat","activate.wizard.error_need_billing_info":"Du skal opdatere din profil med adresse og faktureringsoplysninger for at fortsætte.","activate.wizard.manual_activation_required":"Manual aktivering af dine enheder er påkrævet, som beskrevet på https://sensorclip.dk/da/losninger/priser. Kontakt SensorCLIP for hjælp hertil.","payment.status.msg_failed_fetching_status":"Kunne ikke vise status på aktiveringen. Betalingen behandles dog i baggrunden og enheden vil fremgå af din oversigt, når betalingen er godkendt. Du kan forlade denne side nu","payment.status.cancelled":"Betalingen blev afbrudt og enheden er endnu ikke aktiveret. Gennemfør betalingen igen, hvis dette er en fejl","payment.status.title_approved_awaiting":"Betaling gennemført - afventer godkendelse","payment.status.title_completed":"Betaling gennemført - enhed aktiveret","payment.status.desc_completed":"Vi har nu godkendt din betaling og aktiveret din enhed. I løbet af ganske få minutter bør den fremgå som aktiveret i oversigten.","payment.status.desc_awaiting":"Afventer at systemet godkender kortbetalingen. Dette kan tage et par minutter, hvorefter din enhed automatisk vil blive aktiveret. Du er velkommen til at forlade siden eller blive og følge status herunder.","pagination.showing":"Viser række ","pagination.out_of":" ud af ","units.table.btn_activate":"Aktiver (uden udløb)","units.table.btn_deactivate":"Deaktiver","units.table.btn_remove":"Fjern","units.table.confirm_activate":"Du skal manuelt sende faktura til kunden, hvis relevant. \n\nVil du forsætte?","units.table.confirm_deactivate":"Enheder vil blive deaktiveret men forblive på ejerens oversigt. Eventuel tilbageværende abonnementstid vil blive tabt. \n\nVil du fortsætte?","units.table.confirm_remove":"Vil du virkelig slette enhederne og fjerne dem fra ejerens oversigt?","units.table.msg_no_selection":"Vælg venligst mindst én enhed","units.table.confirm_reload":"Handlingen blev udført. Du kan se resultatet ud for hver enkelt enhed. \n\nØnsker du at genindlæse oversigten for at vise ændringerne?","units.table.column_simcard":"IMEI / ICCID / PIN","units.table.column_simcard_without_imei":"ICCID / PIN","validation.email_invalid":"Angiv venligst en gyldig e-mail","fleetmap.title":"Kort over enheder","fleetmap.checkboxes.show_in_alarm":"Vis - Alarm","fleetmap.checkboxes.show_need_service":"Vis - Service","fleetmap.checkboxes.show_not_in_alarm":"Vis - OK","sensor.service.texts.history":"Historik over tidligere udført service:","sensor.service.dialogs.create_inspection.title":"Indtast service teknikerens navn","sensor.service.dialogs.reset_stats.title":"Bekræft reset","sensor.service.dialogs.reset_stats.text":"Er du sikker på at du vil nulstille tælleren?","sensor.service.reset_stats.msg_completed":"Informationen blev nulstillet","sensor.service.reset_stats.msg_failed":"Informationen kunne ikke nulstilles","sensor.service.tables.summary.last_service_datetime":"Sidste service","sensor.service.tables.summary.next_service":"Næste service","sensor.service.tables.summary.runtime_since_last":"Kørt siden sidste service","sensor.service.tables.summary.actions.order_service_kit":"Bestil servicekit","sensor.service.tables.summary.actions.create_inspection":"Service udført","sensor.service.tables.history.column_technician":"Tekniker","sensor.service.tables.history.column_runtime_total":"Total antal timer kørt","sensor.service.tables.history.column_runtime_since_last":"Timer kørt ved service","sensor.service.headlines.settings":"Indstillinger","sensor.service.headlines.summary":"Opsummering","sensor.service.headlines.history":"Historik","sensor.service.last_service_unknown":"Ingen data","sensor.service.settings.btn_add_more":"Tilføj flere","firmware.upload.title":"Upload ny firmware","firmware.upload.description":"Her kan uploades nye versioner af firmware til SC200 serien.","btn_firmware_upload":"Upload og overskriv","firmware.upload.placeholder_file":"Vælg fil eller træk en fil hertil","firmware.upload.placeholder_drop":"Træk fil hertil","firmware.upload.msg_no_file_chosen":"Vælg venligst en fil","firmware.upload.msg_saved":"Firmwaren blev uploaded","firmware.upload.msg_save_failed":"Firmwaren kunne ikke uploades, tjek venligst at filen er gyldig","firmware.table.btn_refresh_list":"Genindlæs","firmware.table.btn_update":"Opdater valgte","firmware.table.btn_update_cancel":"Annuller for valgte","firmware.table.confirm_update":"Er du sikker på at du vil bede enheden opdatere, næste gang den er online?","firmware.table.confirm_update_cancel":"Er du sikker på at du vil annullere opdateringen for de valgte enheder?","firmware.history.title":"Firmware versioner","firmware.history.table.column_created":"Uploadet","firmware.history.table.column_name":"Filnavn","firmware.history.table.column_checksum":"Checksum","firmware.history.table.empty":"Der er ikke registreret nogen versioner i databasen.","firmware_updates.table.completed.column_firmware":"Version","firmware_updates.table.completed.column_requested":"Planlagt","firmware_updates.table.completed.column_downloaded":"Downloaded","firmware_updates.panel.pending.title":"Planlagte opdateringer","firmware_updates.panel.completed.title":"Gennemførte opdateringer","firmware_updates.panel.pending.desc":"Disse enheder opdateres næste gang de forbinder til serveren.","firmware_updates.table.pending.column_original_fw":"Tidl. version","firmware_updates.table.pending.column_current_fw":"Aktuel version","firmware_updates.table.pending.column_downloaded":"Status","firmware_updates.table.pending.column_requested":"Planlagt","firmware_updates.table.pending.title_last_download":"Seneste download: "}

/***/ }),

/***/ "3ATp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-full navbar-inverse navbar-fixed-top mai-top-header"},[_c('div',{staticClass:"container"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.resetContext($event)}}},[_c('img',{staticClass:"logo",attrs:{"src":"/static/logo.png"}}),_vm._v(" SensorCLIP")]),_vm._v(" "),_c('links'),_vm._v(" "),_c('ul',{staticClass:"nav navbar-nav mai-top-nav"}),_vm._v(" "),_c('div',{staticClass:"mr-3"},[_c('languageSwitcher')],1),_vm._v(" "),_c('top-menu'),_vm._v(" "),_c('user-menu')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "422Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loader_vue__ = __webpack_require__("u0ae");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21b87450_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loader_vue__ = __webpack_require__("cbh6");
function injectStyle (ssrContext) {
  __webpack_require__("1g66")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21b87450"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21b87450_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4d9x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.user.permissions.dashboard_pipeline)?_c('a',{staticClass:"hidden-sm-down",attrs:{"href":"https://sensor.mdevelopment.dk","target":"_blank","id":"pipeline-link"}},[_c('b',[_vm._v("Pipeline")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "50Yw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5GNo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-heading panel-heading-divider"},[(_vm.hasToolsSlot)?_c('div',{staticClass:"float-right"},[_vm._t("tools")],2):_vm._e(),_vm._v("\n        "+_vm._s(_vm.title)+"\n        "),_c('span',{staticClass:"panel-subtitle"},[_vm._v(_vm._s(_vm.subtitle))])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5UxG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__("HSQo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__messages__ = __webpack_require__("sw1b");








var rest = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
    baseURL: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_server
});

rest.interceptors.request.use(function (config) {
    var token = __WEBPACK_IMPORTED_MODULE_4__auth__["a" /* default */].getAuthHeader();
    if (token) {
        config.headers.common['Authorization'] = token;
    }
    return config;
});

rest.interceptors.response.use(null, function (error) {
    if (error.response.data.type === "UnauthorizedTokenInvalid" || error.response.data.type === "UnauthenticatedTokenInvalid") {
        __WEBPACK_IMPORTED_MODULE_4__auth__["a" /* default */].logout();
    }
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Vue.prototype, {
        $rest: {
            get: function get() {
                return rest;
            }
        }
    });
});

/***/ }),

/***/ "5zCw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_register_vue__ = __webpack_require__("txGb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a68a844_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_register_vue__ = __webpack_require__("pMIF");
function injectStyle (ssrContext) {
  __webpack_require__("M52M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a68a844_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6bGd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Rax":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateSensorSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deactivateSensor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeSensor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");


var fields = ['label', 'connect_time', 'wakeup', 'power_factor', 'power_off_delay', 'max_runtime', 'max_runtime_delay', 'voltage', 'alarm_delay', 'alarm_delay_2', 'calibration', 'calibration_2', 'temperature_limits', 'temperature_limits_2', 'reminder', 'resync', 'digital_input_delay', 'pulse_input', 'power_max_idle', 'power_limits_delay', 'power_limits', 'hibernate_max_power', 'service_interval', 'servicekit_interval', 'service_notification_enabled', 'service_notification_email', 'servicekit_notification_email'];

var updateSensorSettings = function updateSensorSettings(_ref, settings) {
    var state = _ref.state,
        commit = _ref.commit;

    var data = {};

    for (var key in settings) {
        if (settings.hasOwnProperty(key)) {
            if (fields.indexOf(key) > -1) data[key] = settings[key];
        }
    }

    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$rest.put("/sensor/" + settings.id + "/settings", data).then(function () {
        settings.serial = settings.id;
        commit("sensorUpdated", settings);
    });
};

var deactivateSensor = function deactivateSensor(_ref2, sensor) {
    var state = _ref2.state,
        commit = _ref2.commit;

    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$rest.delete("/sensor/" + sensor.serial + "/activation").then(function () {
        commit("sensorRemoved", sensor);
    });
};

var removeSensor = function removeSensor(_ref3, sensor) {
    var state = _ref3.state,
        commit = _ref3.commit;

    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$rest.delete("/sensor/" + sensor.serial).then(function () {
        commit("sensorRemoved", sensor);
    });
};

/***/ }),

/***/ "9m5w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fromAPIData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);



var sensor = {
    id: 0,
    label: null,
    type: null,
    activated: false,
    alarm: false,
    battery: null,
    firmware: null,
    iccid: null,
    imei: null,
    last_connected: null,
    measurement: null,
    owner: 0,
    pin: null,
    serial: null,
    signal: null,
    subscription_end: null,

    settings: {}
};

var fromAPIData = function fromAPIData(raw) {

    var sensor = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(raw)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

            var key = _ref2[0];
            var value = _ref2[1];

            sensor[key] = value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return sensor;
};

/* unused harmony default export */ var _unused_webpack_default_export = (sensor);

/***/ }),

/***/ "9yKr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__("+BXW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ae2602b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_input_vue__ = __webpack_require__("TFOn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ae2602b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BHyr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_language_switcher_vue__ = __webpack_require__("vGaQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c37a9f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_language_switcher_vue__ = __webpack_require__("0GqW");
function injectStyle (ssrContext) {
  __webpack_require__("INnc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63c37a9f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_language_switcher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c37a9f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_language_switcher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BJcI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"}},[_vm._v(_vm._s(_vm.content))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DXda":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('topbar'),_vm._v(" "),_c('nav',{staticClass:"navbar mai-sub-header"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"navbar navbar-toggleable-sm"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.mai-navbar-collapse",modifiers:{"mai-navbar-collapse":true}}],staticClass:"navbar-toggler hidden-md-up collapsed",attrs:{"aria-controls":"#mai-navbar-collapse","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('div',{staticClass:"icon-bar"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])]),_vm._v(" "),_c('b-collapse',{staticClass:"navbar-collapse collapse mai-nav-tabs",attrs:{"id":"mai-navbar-collapse"}},[_c('main-menu')],1)],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DoXa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__links_vue__ = __webpack_require__("UQJ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usermenu_vue__ = __webpack_require__("eEvK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__topmenu_vue__ = __webpack_require__("LaxX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__snippets_language_switcher_vue__ = __webpack_require__("BHyr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        userMenu: __WEBPACK_IMPORTED_MODULE_1__usermenu_vue__["a" /* default */],
        topMenu: __WEBPACK_IMPORTED_MODULE_2__topmenu_vue__["a" /* default */],
        links: __WEBPACK_IMPORTED_MODULE_0__links_vue__["a" /* default */],
        languageSwitcher: __WEBPACK_IMPORTED_MODULE_3__snippets_language_switcher_vue__["a" /* default */]
    },
    methods: {
        resetContext: function resetContext() {
            this.$store.commit("clearContext");
            this.$router.push({ name: "dashboard" });
        }
    }
});

/***/ }),

/***/ "DxRk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUserFromLoginObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatPermissions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);


var user = {
    id: 0,
    name: '',
    permissions: {
        public: true
    },
    info: {
        email_invoice: '',
        adr1: '',
        adr2: '',
        adr3: '',
        postcode: '',
        city: '',
        country: '',
        phone: '',
        vat_number: ''
    }
};

function getUserFromLoginObject(data) {
    user.id = data.userid;
    user.name = data.name;
    user.permissions = formatPermissions(data.permissions);

    return user;
}

function formatPermissions(permissions) {
    var result = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(permissions)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var perm = _step.value;

            if (permissions[perm] === true) // Sanitize
                {
                    var name = perm.split(".").join("_");
                    name = name.split("-").join("_");
                    result[name] = true;
                }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return result;
}

/* unused harmony default export */ var _unused_webpack_default_export = (user);

/***/ }),

/***/ "Dy+K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return overwriteFirmware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchFirmwareHistory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");


var overwriteFirmware = function overwriteFirmware(_ref, _ref2) {
    var state = _ref.state,
        commit = _ref.commit;
    var file = _ref2.file;

    var data = new FormData();
    data.set("file", file);

    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$rest.post("/firmware", data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

var fetchFirmwareHistory = function fetchFirmwareHistory(_ref3) {
    var commit = _ref3.commit,
        getters = _ref3.getters;

    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$rest.get("/firmware").then(function (content) {
        commit("setFirmwareHistory", content.data);
    });
};

/***/ }),

/***/ "EV1k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__("broi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_703379aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__("tOiY");
function injectStyle (ssrContext) {
  __webpack_require__("6bGd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-703379aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_703379aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GifL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasItems)?_c('ul',{staticClass:"navbar-nav float-lg-right mai-icons-nav"},[(_vm.$store.state.user.permissions.user_manage_everybody)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.resetContext($event)}}},[_vm._v(_vm._s(_vm.$t('topmenu.search')))])]):_vm._e(),_vm._v(" "),(_vm.$store.state.user.permissions.user_manage_everybody && _vm.noContext)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link hidden-sm-down",attrs:{"to":{name: 'requisitions'}}},[_vm._v(_vm._s(_vm.$t('topmenu.requisitions')))])],1):_vm._e(),_vm._v(" "),(_vm.showCustomerUnits)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link hidden-sm-down",attrs:{"to":{name: 'sensors.table'}}},[_vm._v(_vm._s(_vm.$t('topmenu.customer_units')))])],1):_vm._e(),_vm._v(" "),(_vm.showCustomerFirmwareUpdate)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link hidden-sm-down",attrs:{"to":{name: 'sensors.firmware.updates'}}},[_vm._v(_vm._s(_vm.$t('topmenu.firmware_update')))])],1):_vm._e(),_vm._v(" "),(_vm.showMyUnits)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link hidden-sm-down",attrs:{"to":{name: 'sensors.table'}}},[_vm._v(_vm._s(_vm.$t('topmenu.my_units')))])],1):_vm._e(),_vm._v(" "),(_vm.showCustomerActivity)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link hidden-sm-down",attrs:{"to":{name: 'activity'}}},[_vm._v(_vm._s(_vm.$t('topmenu.activity')))])],1):_vm._e(),_vm._v(" "),(_vm.$store.state.user.permissions.api_manage && _vm.noContext)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link hidden-sm-down",attrs:{"to":{name: 'firmware'}}},[_vm._v(_vm._s(_vm.$t('topmenu.firmware')))])],1):_vm._e(),_vm._v(" "),(_vm.$store.state.user.permissions.api_manage && _vm.noContext)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link hidden-sm-down",attrs:{"to":{name: 'api'}}},[_vm._v(_vm._s(_vm.$t('topmenu.api')))])],1):_vm._e(),_vm._v(" "),(_vm.$store.state.user.permissions.api_manage && _vm.noContext)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link hidden-sm-down",attrs:{"to":{name: 'expired'}}},[_vm._v("Udløbet")])],1):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H9j1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user__ = __webpack_require__("DxRk");



var updateContext = function updateContext(_ref, info) {
    var state = _ref.state,
        commit = _ref.commit;

    // Get permissions for user
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$rest.get("/user/" + info.id + "/permission").then(function (content) {
        var usr = {}; //userObj;
        usr.id = info.id;
        usr.name = info.name;
        usr.email = info.email;
        usr.info = info;

        // TODO: Insert permissions
        var permissions = content.data;
        delete permissions.users;
        usr.permissions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__user__["b" /* formatPermissions */])(permissions);

        commit("setContext", usr);
    });
};

/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__("fcFS");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("0EFW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hh2S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setLanguage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");



var setLanguage = function setLanguage(_ref, language) {
    var commit = _ref.commit;

    commit("setLanguage", language);

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$polyglot.setLang({ lang: language });
    __WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].localize(language);
};

/***/ }),

/***/ "Hy2l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messages"},_vm._l((_vm.messages),function(item){return _c('b-alert',{key:item.message,attrs:{"show":"","dismissible":"","variant":item.variant}},[_vm._v(_vm._s(item.message))])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "INnc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sensor__ = __webpack_require__("9m5w");







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
    user: null,
    loginAttempts: 0,
    sensors: [],
    contacts: [],
    alerting_contacts: [],
    context: null,
    contextPath: [],
    language: 'da',
    firmware_versions: []
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: state,
    actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
    getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
    modules: {
        //auth,
    },
    debug: "production" !== 'production',
    strict: "production" !== 'production'
}));

/***/ }),

/***/ "J5b6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recover_vue__ = __webpack_require__("MAPX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8802e5b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recover_vue__ = __webpack_require__("dCB4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8802e5b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recover_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("aPSQ");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("k0Yb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__("kJiG");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("vkIy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JMHp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-3 col-form-label",class:{'text-md-right': !_vm.left}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{class:{'col-9 col-md-6': !_vm.fullWidth, 'col-8': _vm.fullWidth}},[_vm._t("default")],2),_vm._v(" "),(!_vm.fullWidth)?_c('div',{staticClass:"col-md-3 offset-md-0 col-9 offset-3"},[_vm._t("help")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KHRN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_submenu_vue__ = __webpack_require__("U+4G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e310512_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_submenu_vue__ = __webpack_require__("m76j");
function injectStyle (ssrContext) {
  __webpack_require__("UmPW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_submenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e310512_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_submenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KWv7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
var dashboard = function dashboard() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "1QUN"));
};
var sensorDashboard = function sensorDashboard() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "7TUx"));
};
var resellerDashboard = function resellerDashboard() {
    return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "dOiX"));
};
var sensors = function sensors() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "YjCf"));
};
var sensorsFirmwareUpdates = function sensorsFirmwareUpdates() {
    return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "XlgD"));
};
var applicationLogging = function applicationLogging() {
    return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "/jki"));
};
var sensorsAdd = function sensorsAdd() {
    return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "4J5q"));
};
var paymentStatus = function paymentStatus() {
    return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "3Hac"));
};
var report = function report() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "oQLw"));
};
var comments = function comments() {
    return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "n2FD"));
};
var contacts = function contacts() {
    return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "TDui"));
};
var contactsAdd = function contactsAdd() {
    return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "2tCJ"));
};
var contactsAdd2 = function contactsAdd2() {
    return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "9Hn2"));
};
var contactsEdit = function contactsEdit() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "t1bD"));
};
var alertingList = function alertingList() {
    return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "JN3o"));
};
var alertingAdd = function alertingAdd() {
    return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, "zl2o"));
};
var contactsEditAssignments = function contactsEditAssignments() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "t1bD"));
};
var multiConfigureContacts = function multiConfigureContacts() {
    return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "CQWQ"));
};
var alarms = function alarms() {
    return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "jbSU"));
};
var profile = function profile() {
    return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "MxVX"));
};
var contextProfile = function contextProfile() {
    return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "f/bN"));
};
var deleteProfile = function deleteProfile() {
    return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "h9vv"));
};
var api = function api() {
    return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, "aRcG"));
};
var firmware = function firmware() {
    return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, "++nW"));
};
var fleetmap = function fleetmap() {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "av/K"));
};
var cronExpired = function cronExpired() {
    return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "A2nr"));
};
var requisition = function requisition() {
    return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "fZue"));
};
var usersAdd = function usersAdd() {
    return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "lkc8"));
};
var activityLog = function activityLog() {
    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "w7jI"));
};
var permissions = function permissions() {
    return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "yW9C"));
};
var usersAttach = function usersAttach() {
    return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, "nh4c"));
};
var usersDetach = function usersDetach() {
    return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "3b5F"));
};


var isTargetClient = ['or', ['context_exists', ['not', 'context_user_manage_others']], [['not', 'user_manage_others']]];

var isTargetReseller = ['or', [['not', 'context_exists'], 'user_manage_others', ['not', 'user_manage_everybody']], ['context_user_manage_others', ['not', 'context_user_manage_everybody']]];

var canTargetAssignUnit = ['sensor_add', ['or', ['not', 'user_manage_everybody'], 'context_exists']];

var itemReturnDashboard = {
    target: 'dashboard',
    meta: {
        inMainmenu: true,
        label: 'menu.back_dashboard',
        icon: 's7-left-arrow',
        permissions: []
    }
};

var itemReturnContacts = {
    target: 'contacts',
    meta: {
        inMainmenu: true,
        label: 'menu.back_contacts',
        icon: 's7-left-arrow',
        permissions: []
    }
};

var itemReturnAlerting = {
    target: 'alerting',
    meta: {
        inMainmenu: true,
        label: 'menu.back_alerting',
        icon: 's7-left-arrow',
        permissions: []
    }
};

var routes = [{
    name: 'dashboard',
    path: '/',
    component: dashboard,
    meta: {
        inMainmenu: true,
        label: 'menu.overview',
        icon: 's7-display1',
        permissions: []
    },
    submenu: [{
        target: 'usersAdd',
        meta: {
            inMainmenu: true,
            label: 'menu.create_account',
            icon: 's7-plus',
            permissions: ['user_create', ['or', ['not', 'context_exists'], 'context_user_create']]
        }
    }, {
        target: 'usersAttach',
        meta: {
            inMainmenu: true,
            label: 'menu.assign_account',
            icon: 's7-add-user',
            permissions: ['user_edit_other', ['or', ['context_exists', 'context_user_manage_others'], [['not', 'context_exists'], 'user_manage_others']], ['or', ['context_exists', ['not', 'context_user_manage_everybody']], [['not', 'context_exists'], ['not', 'user_manage_everybody']]]]
        }
    }, {
        target: 'usersDetach',
        meta: {
            inMainmenu: true,
            label: 'menu.detach_account',
            icon: 's7-delete-user',
            permissions: ['user_edit_other', ['or', ['context_exists', 'context_user_manage_others']], ['or', ['context_exists', ['not', 'context_user_manage_everybody']], [['not', 'context_exists'], ['not', 'user_manage_everybody']]]]
        }
    }, {
        target: 'sensorsAdd',
        meta: {
            inMainmenu: true,
            label: 'menu.add_unit',
            icon: 's7-plus',
            permissions: [canTargetAssignUnit]
        }
    }, {
        target: 'multiConfContacts',
        meta: {
            inMainmenu: true,
            label: 'menu.conf_contacts',
            icon: 's7-users',
            permissions: ['contact_manage', isTargetClient]
        }
    }]
}, /*
   {
    name: 'dashboardAlias',
    path: '/',
    component: dashboard,
    meta: {
        inMainmenu: false,
        permissions: []
    }
   },*/
{
    name: 'dashboardWrapper',
    path: '/Kunde/:id',
    component: dashboard,
    meta: {
        inMainmenu: false,
        permissions: ['user_manage_others']
    }
}, {
    name: 'resellerDashboard',
    path: '/Kunder',
    component: resellerDashboard,
    meta: {
        inMainmenu: false,
        permissions: ['user_manage_others']
    }
}, {
    name: 'fleetmap',
    path: '/Kort',
    component: fleetmap,
    meta: {
        inMainmenu: true,
        label: 'menu.fleetmap',
        icon: 's7-map',
        permissions: ['sensor_view', ['or', isTargetClient, isTargetReseller]]
    },
    submenu: [itemReturnDashboard]
}, {
    name: 'alarms',
    path: '/Alarmer',
    component: alarms,
    meta: {
        inMainmenu: true,
        label: 'menu.alarms',
        icon: 's7-speaker',
        permissions: ['sensor_view', isTargetClient]
    }
}, {
    name: 'report',
    path: '/Rapport',
    component: report,
    meta: {
        inMainmenu: true,
        label: 'menu.report',
        icon: 's7-note2',
        permissions: [
        //'report_view',
        isTargetClient]
    },
    submenu: [itemReturnDashboard]
}, {
    name: 'activity',
    path: '/Aktivitet',
    component: activityLog,
    meta: {
        inMainmenu: false,
        permissions: ['context_exists', 'activity_view']
    },
    submenu: [itemReturnDashboard]
}, {
    name: 'sensors.firmware.updates',
    path: '/Hardware',
    component: sensorsFirmwareUpdates,
    meta: {
        inMainmenu: false,
        permissions: ['context_exists', 'user_manage_others']
    },
    submenu: [itemReturnDashboard]
}, {
    name: 'application.logs',
    path: '/Udvikler/Logs',
    component: applicationLogging,
    meta: {
        inMainmenu: false,
        permissions: ['context_exists', 'user_manage_others']
    },
    submenu: [itemReturnDashboard]
}, {
    name: 'permissions',
    path: '/Rettigheder',
    component: permissions,
    meta: {
        inMainmenu: true,
        label: 'menu.permissions',
        icon: 's7-users',
        permissions: ['context_exists', 'user_edit_other']
    },
    submenu: [itemReturnDashboard]
}, {
    name: 'contacts',
    path: '/Kontaktpersoner',
    component: contacts,
    meta: {
        inMainmenu: true,
        label: 'menu.contacts',
        icon: 's7-users',
        permissions: ['contact_manage', isTargetClient]
    },
    submenu: [{
        target: 'contacts.add',
        meta: {
            inMainmenu: true,
            label: 'menu.contacts_add',
            icon: 's7-plus',
            permissions: ['contact_manage', isTargetClient]
        }
    }]
}, {
    name: 'contacts.edit',
    path: '/Kontaktpersoner/:id/Rediger',
    component: contactsEdit,
    meta: {
        inMainmenu: false,
        permissions: ['contact_manage']
    }
},
/*{
    name: 'contacts.assignments.edit',
    path: '/Kontaktpersoner/:id/Enheder',
    component: contactsEditAssignments,
    meta: {
        inMainmenu: true,
        noLabel: true,
        permissions: [
            'contact_manage'
        ]
    },
    submenu: [
        itemReturnContacts
    ]
},*/
{
    name: 'contacts.add',
    path: '/Kontaktpersoner/Opret',
    component: contactsAdd,
    alias: '/Kontaktpersoner/Opret/:sensor',
    meta: {
        inMainmenu: true,
        noLabel: true,
        permissions: ['contact_manage', isTargetClient]
    },
    submenu: [itemReturnContacts]
}, {
    name: 'contacts.add.sensor2',
    path: '/Kontaktpersoner/Opret/2',
    component: contactsAdd2,
    meta: {
        inMainmenu: true,
        noLabel: true,
        permissions: ['contact_manage', isTargetClient, 'sensor_view_extra']
    },
    submenu: [itemReturnContacts]
}, {
    name: 'comments',
    path: '/Kommentarer',
    component: comments,
    meta: {
        inMainmenu: true,
        label: 'menu.comments',
        icon: 's7-comment',
        permissions: ['comment_manage', 'context_exists']
    }
}, {
    name: 'alerting',
    path: '/Alarmering',
    component: alertingList,
    meta: {
        inMainmenu: true,
        noLabel: false,
        label: 'menu.alerting',
        icon: 's7-call',
        permissions: [
        /*['or', ['context_exists', 'context_user_manage_others'], [['not', 'context_exists'], 'user_manage_others']],
        ['or', ['context_exists', ['not', 'context_user_manage_everybody']], [['not', 'context_exists'], ['not', 'user_manage_everybody']]]*/
        isTargetReseller]
    },
    submenu: [itemReturnDashboard, {
        target: 'alerting.add',
        meta: {
            inMainmenu: true,
            label: 'menu.alerting_add',
            icon: 's7-plus',
            permissions: [isTargetReseller]
        }
    }]
}, {
    name: 'alerting.add',
    path: '/Alarmering/Opret',
    component: alertingAdd,
    alias: '/Alarmering/Opret/:sensor',
    meta: {
        inMainmenu: true,
        noLabel: true,
        permissions: [isTargetReseller]
    },
    submenu: [itemReturnAlerting]
}, {
    name: 'profile',
    path: '/Profil',
    component: profile,
    meta: {
        inMainmenu: false,
        label: 'menu.profile',
        icon: 's7-tools',
        permissions: []
    }
}, {
    name: 'profileOwn',
    path: '/Profil',
    component: profile,
    meta: {
        inMainmenu: true,
        label: 'menu.profile',
        icon: 's7-tools',
        permissions: [['not', 'context_exists']]
    }
}, {
    name: 'contextProfile',
    path: '/Info',
    component: contextProfile,
    meta: {
        inMainmenu: true,
        label: 'menu.profile',
        icon: 's7-tools',
        permissions: ['context_exists']
    }
}, {
    name: 'deleteProfile',
    path: '/Opsig',
    component: deleteProfile,
    meta: {
        inMainmenu: false,
        label: 'menu.profile_delete',
        icon: 's7-remove',
        permissions: ['user_delete']
    }
}, {
    name: 'sensors.table',
    path: '/Enheder',
    component: sensors,
    meta: {
        inMainmenu: false,
        label: 'menu.units',
        icon: 's7-users',
        permissions: ['sensor_view']
    }
}, {
    name: 'api',
    path: '/API',
    component: api,
    meta: {
        inMainmenu: false,
        permissions: ['api_manage']
    }
}, {
    name: 'firmware',
    path: '/Firmware',
    component: firmware,
    meta: {
        inMainmenu: false,
        permissions: ['api_manage']
    }
}, {
    name: 'expired',
    path: '/Cron/Expired',
    component: cronExpired,
    meta: {
        inMainmenu: false,
        permissions: ['api_manage']
    }
}, {
    name: 'usersAdd',
    path: '/Konti/Opret',
    component: usersAdd,
    meta: {
        inMainmenu: true,
        noLabel: true,
        permissions: ['user_create', ['or', ['not', 'context_exists'], 'context_user_create']]
    },
    submenu: [itemReturnDashboard]
}, {
    name: 'usersAttach',
    path: '/Konti/Tilknyt',
    component: usersAttach,
    meta: {
        inMainmenu: true,
        noLabel: true,
        permissions: ['user_edit_other', ['or', ['context_exists', 'context_user_manage_others'], [['not', 'context_exists'], 'user_manage_others']], ['or', ['context_exists', ['not', 'context_user_manage_everybody']], [['not', 'context_exists'], ['not', 'user_manage_everybody']]]]
    },
    submenu: [itemReturnDashboard]
}, {
    name: 'usersDetach',
    path: '/Konti/Fjern',
    component: usersDetach,
    meta: {
        inMainmenu: true,
        noLabel: true,
        permissions: ['user_edit_other', ['or', ['context_exists', 'context_user_manage_others'], [['not', 'context_exists'], 'user_manage_others']], ['or', ['context_exists', ['not', 'context_user_manage_everybody']], [['not', 'context_exists'], ['not', 'user_manage_everybody']]]]
    },
    submenu: [itemReturnDashboard]
}, {
    name: 'sensorsAdd',
    path: '/Sensor/:sensor?/Opret',
    component: sensorsAdd,
    meta: {
        inMainmenu: true,
        noLabel: true,
        permissions: [canTargetAssignUnit]
    },
    submenu: [itemReturnDashboard]
}, {
    name: 'cardPaymentStatus',
    path: '/Betaling/Sensor/:sensor/:status',
    component: paymentStatus,
    meta: {
        inMainmenu: false,
        noLabel: true,
        permissions: [canTargetAssignUnit]
    },
    submenu: [itemReturnDashboard]
}, {
    name: 'multiConfContacts',
    path: '/Konfigurer/Alarmmodtagere',
    component: multiConfigureContacts,
    meta: {
        inMainmenu: true,
        noLabel: true,
        permissions: ['contact_manage', isTargetClient]
    },
    submenu: [itemReturnDashboard]
}, {
    name: 'requisitions',
    path: '/Rekvisitioner',
    component: requisition,
    meta: {
        inMainmenu: false,
        noLabel: true,
        permissions: ['user_manage_everybody']
    },
    submenu: [itemReturnDashboard]
}];

/***/ }),

/***/ "KlCj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menus_mainmenu_vue__ = __webpack_require__("XyYb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__topbar_topbar_vue__ = __webpack_require__("dxxY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        mainMenu: __WEBPACK_IMPORTED_MODULE_0__menus_mainmenu_vue__["a" /* default */],
        topbar: __WEBPACK_IMPORTED_MODULE_1__topbar_topbar_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "LPfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoggedIn)?_c('div',{staticClass:"mai-wrapper"},[_c('theme-header'),_vm._v(" "),_c('div',{staticClass:"main-content container"},[_c('message-boxes'),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('theme-footer')],1):_c('login-page'),_vm._v(" "),_c('modals-container'),_vm._v(" "),_c('v-dialog')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LaxX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topmenu_vue__ = __webpack_require__("NHwx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_333e7fb5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_topmenu_vue__ = __webpack_require__("GifL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topmenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_333e7fb5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_topmenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LzJX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_row_vue__ = __webpack_require__("022v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_369fb796_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_row_vue__ = __webpack_require__("JMHp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_row_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_369fb796_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_row_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M52M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c5785de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("LPfa");
function injectStyle (ssrContext) {
  __webpack_require__("1wrJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c5785de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MAPX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            email: ""
        };
    },

    computed: {
        modified: function modified() {
            return this.email.length > 0;
        }
    },
    methods: {
        confirmBack: function confirmBack() {
            if (!this.modified || confirm("Er du sikker på du vil annullere og gå tilbage?")) {
                this.$emit('back');
            }
        }
    }
});

/***/ }),

/***/ "MJyD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_auth__ = __webpack_require__("TIfe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            isOpen: false
        };
    },

    computed: {
        overlaying: function overlaying() {
            return this.overlayUser !== "";
        },
        overlayUser: function overlayUser() {
            var contextUser = this.$store.getters.getContextUser;
            if (contextUser !== null && contextUser.id !== this.$store.state.user.id) return this.$store.getters.getContextUser.name;else return "";
        }
    },
    methods: {
        toggleMenu: function toggleMenu() {
            this.isOpen = !this.isOpen;

            if (this.isOpen) {
                // Register event listener
                document.addEventListener('click', this.closeMenu);
            } else {
                // Cleanup
                closeMenu();
            }
        },
        handleLogout: function handleLogout() {
            __WEBPACK_IMPORTED_MODULE_0__utils_auth__["a" /* default */].logout();
        },
        closeMenu: function closeMenu() {
            this.isOpen = false;
            document.removeEventListener('click', this.closeMenu);
        }
    }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_rest__ = __webpack_require__("5UxG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate_dist_locale_da__ = __webpack_require__("wTRM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate_dist_locale_da___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vee_validate_dist_locale_da__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lang_js__ = __webpack_require__("+yMS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_layout_snippets_loader_vue__ = __webpack_require__("422Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_layout_snippets_panel_vue__ = __webpack_require__("+jXL");













// Config
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.debug = true;

// Form validation langugage
__WEBPACK_IMPORTED_MODULE_8_vee_validate__["a" /* Validator */].localize('da', __WEBPACK_IMPORTED_MODULE_7_vee_validate_dist_locale_da___default.a);
__WEBPACK_IMPORTED_MODULE_8_vee_validate__["a" /* Validator */].extend('password_repeat', {
    getMessage: function getMessage(field) {
        return 'De to adgangskoder skal være ens';
    },
    validate: function validate(value, targetValue) {
        return value === targetValue.toString();
    }
});

// Add dependencies
var VueCookie = __webpack_require__("K/Lq");
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(VueCookie);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_js_modal___default.a, {
    dialog: true,
    dynamic: true
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vee_validate__["b" /* default */], {
    inject: false,
    dictionary: {
        da: {
            attributes: {
                'email': 'E-mail',
                'phone': 'Telefon',
                'name': 'Navn',
                'password': 'Adgangskode',
                'password2': 'Gentaget adgangskode'
            }
        }
    }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__utils_rest__["a" /* default */]);

// Add snippets



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('loader', __WEBPACK_IMPORTED_MODULE_11__components_layout_snippets_loader_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('panel', __WEBPACK_IMPORTED_MODULE_12__components_layout_snippets_panel_vue__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]);
    }
});

/***/ }),

/***/ "NHwx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_functions__ = __webpack_require__("U6DU");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        showCustomerUnits: function showCustomerUnits() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__router_functions__["a" /* canAccess */])(['user_manage_everybody', 'context_exists']);
        },
        showMyUnits: function showMyUnits() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__router_functions__["a" /* canAccess */])(['user_manage_others']) && this.noContext;
        },
        showCustomerActivity: function showCustomerActivity() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__router_functions__["a" /* canAccess */])(['activity_view', 'context_exists']);
        },
        showCustomerFirmwareUpdate: function showCustomerFirmwareUpdate() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__router_functions__["a" /* canAccess */])(['user_manage_everybody', 'context_exists']);
        },
        noContext: function noContext() {
            return this.$store.getters.getTargetContext.id === this.$store.getters.getUser.id;
        },
        hasItems: function hasItems() {
            return this.$store.state.user.permissions.user_manage_everybody && this.noContext || this.showCustomerUnits || this.showMyUnits || this.showCustomerActivity || this.showCustomerFirmwareUpdate || this.$store.state.user.permissions.api_manage && this.noContext;
        }
    },
    methods: {
        resetContext: function resetContext() {
            this.$store.commit("clearContext");
            this.$router.push({ name: "dashboard" });
        }
    }
});

/***/ }),

/***/ "NQPl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_messages__ = __webpack_require__("sw1b");

//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        target: {
            type: String,
            default: null
        }
    },
    data: function data() {
        var _icons, _classes, _variants;

        return {
            notifications: [],
            icons: (_icons = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_icons, __WEBPACK_IMPORTED_MODULE_1__utils_messages__["a" /* SUCCESS */], 'icon s7-check'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_icons, __WEBPACK_IMPORTED_MODULE_1__utils_messages__["b" /* ERROR */], null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_icons, __WEBPACK_IMPORTED_MODULE_1__utils_messages__["c" /* INFO */], 'icon s7-info'), _icons),
            classes: (_classes = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classes, __WEBPACK_IMPORTED_MODULE_1__utils_messages__["a" /* SUCCESS */], 'alert alert-dismissible alert-success'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classes, __WEBPACK_IMPORTED_MODULE_1__utils_messages__["b" /* ERROR */], 'alert alert-dismissible alert-danger'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classes, __WEBPACK_IMPORTED_MODULE_1__utils_messages__["c" /* INFO */], 'alert alert-dismissible alert-info'), _classes),
            variants: (_variants = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_variants, __WEBPACK_IMPORTED_MODULE_1__utils_messages__["a" /* SUCCESS */], 'success'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_variants, __WEBPACK_IMPORTED_MODULE_1__utils_messages__["b" /* ERROR */], 'danger'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_variants, __WEBPACK_IMPORTED_MODULE_1__utils_messages__["c" /* INFO */], 'info'), _variants)
        };
    },
    computed: {
        messages: function messages() {
            return this.notifications;
        }
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_1__utils_messages__["d" /* default */].bus.$on('message', function ($event) {
            $event.icon = _this.icons[$event.type];
            $event.class = _this.classes[$event.type];
            $event.variant = _this.variants[$event.type];

            if ($event.target !== null && $event.target !== undefined && $event.target !== _this.target) return;

            // Append message
            _this.notifications.push($event);

            // Overwrite message
            //this.notifications = [$event];
        });
        __WEBPACK_IMPORTED_MODULE_1__utils_messages__["d" /* default */].bus.$on('message.clear', function ($event) {
            _this.notifications = [];
        });
    }
});

/***/ }),

/***/ "PZJq":
/***/ (function(module, exports) {

module.exports = {"login.btn_create_account":"Create account","login.btn_login":"Login","login.btn_reset_pwd":"Reset password","login.create.title":"Create account","login.create.desc":"You will only be able to use the control panel if you have bought a SensorCLIP. However you can always register and buy it later.","login.create.confirm_back":"Are you sure you want to cancel and go back?","login.create.email_in_use":"The email is already registered","login.create.generic_error":"Your account could not be created. Please Din bruger kunne ikke oprettes. Review your information below or contact support.","login.forgotten.title":"Forgot the password?","login.forgotten.desc":"Contact our support for assistance in accessing your account. You can find our contact information via the link below:","msg.error":"An error occured and the action could not be completed","msg.error_loading":"Could not load information","msg.error_loading_units_with_pending_updates":"Could not fetch units pending firmware updates","customer":"Customer","customers":"Customers","alarm":"Alarm","alarms":"Alarms","unit":"Department","units":"Departments","processing":"Working...","loading":"Loading...","label.email":"Email","label.email_billing":"Billing email","label.sms":"SMS","label.name":"Name","label.phone":"Phone","label.password":"Password","label.actions":"Actions","label.time":"Time","label.message":"Message","label.comment":"Comment","label.serial":"Serial","label.subscription":"Subscription","label.user":"User","label.type":"Type","label.sensorunit":"Unit","label.pin":"PIN","label.imei":"IMEI","label.iccid":"ICCID","label.hardware":"Hardware model","label.firmware":"Firmware version","label.signal":"Signalstrength","label.battery":"Battery","label.expires":"Expires","expires.never":"Never","expires.already_expired":"Expired","label.sensor_internal":"Internal","label.sensor_external":"External","label.sensor":"Sensor","label.password_repeat":"Repeat password","label.new_password":"New password","label.permissions":"Permissions","label.receiver":"Receiver","label.cvr":"VAT","label.address1":"Address 1","label.address2":"Address 2","label.address3":"Contact person","label.zipcode":"Zipcode","label.city":"City","label.country":"Country","label.choose_checkbox":"Choose","btn_change_password":"Change password","btn_delete_profile":"Delete profile","btn_back":"Back","btn_edit":"Edit","btn_save":"Save","btn_remove":"Remove","btn_delete":"Delete","btn_cancel":"Cancel","btn_print":"Print","btn_next":"Next","btn_prev":"Previous","btn_reset":"Reset","btn_close":"Close","btn_yes":"Yes","btn_no":"No","monday":"Monday","tuesday":"Tuesday","wednesday":"Wednesday","thursday":"Thursday","friday":"Friday","saturday":"Saturday","sunday":"Sunday","menu.overview":"Overview","menu.create_account":"Create account","menu.assign_account":"Attach account","menu.detach_account":"Detach account","menu.add_unit":"Create unit","menu.fleetmap":"Map","menu.alarms":"Alarms","menu.alerting":"Alerting","menu.alerting_add":"Create new","menu.report":"Report","menu.permissions":"Permissions","menu.contacts":"Contacts","menu.contacts_add":"Create new","menu.comments":"Comments","menu.profile":"Profile","menu.profile_delete":"Delete profile","menu.units":"Units","menu.back_dashboard":"Back to dashboard","menu.back_contacts":"Back to contacts","menu.back_alerting":"Back to list","topmenu.activity":"Activity","topmenu.search":"Search","topmenu.api":"API","topmenu.customer_units":"Customers units","topmenu.requisitions":"New units","topmenu.my_units":"My units","topmenu.my_profile":"My profile","topmenu.logout":"Logout","topmenu.firmware_update":"Firmware Update","topmenu.firmware":"Firmware","dashboard.fetch_more":"Load more","dashboard.alarm":"alarm","dashboard.alarms":"alarms","dashboard.error_fetching_active":"An error occured while fetching number of current alarms","dashboard.error_fetching_user":"Could not fetch info about chosen user","dashboard.filter.customer_label":"Search for customer or unit","dashboard.filter.customer_placeholder":"Name, address, serial","dashboard.filter.unit_label":"Search for department or unit","dashboard.filter.unit_placeholder":"Name, address, serial","dashboard.filter.device_label":"Search for unit","dashboard.filter.device_placeholder":"Name or serial","dashboard.filter.zoom_label":"Zoom","dashboard.filter.zoom_placeholder":"Zoom","dashboard.no_units_yet":"You have no assigned units yet. Click on the button 'Create Unit' above to get started.","dashboard.title.my_units":"My units","sensor.last_connected":"Last connected","sensor.add_subscription":"Add subscription","sensor.deactivated":"This unit is deactivated as it has no active subscription.","sensor.btn_remove_deactivated":"Remove from account","sensor.msg_confirm_remove_deactivated":"Are you sure you want to remove the unit?","sensor.tab.general":"General","sensor.tab.settings":"Settings","sensor.tab.receivers":"Alarm receiver","sensor.tab.alarms":"Alarms","sensor.tab.location":"Location","sensor.tab.logs":"Measurements","sensor.tab.service":"Service","sensor.tab.rules":"Alarm rules","sensor.tab.comments":"Comments","sensor.tab.images":"Uploads","sensor.tab.subscription":"Subscription","sensor.general.btn_subscribe_extend":"Extend","sensor.general.btn_unsubscribe":"Remove","sensor.general.confirm_unsubscribe":"This unit will be removed from your account. Any related settings or log will be deleted irreversibly. \n\nAre you sure, you want to continue?","sensor.general.msg_unsubscribed":"The unit was removed from your account","sensor.contacts.none":"No alarm receiver attached. Nobody will receive any notices upon an alarm from this unit.","sensor.contacts.btn_add":"New receiver","sensor.contacts.btn_assign":"Attach receiver","sensor.contacts.confirm_removal":"Are you sure you want to remove this receiver?","sensor.rules.desc":"You can disable notifications for specific time periods. If an alarm has occurred in one of the specified times, you will never be notified - even if it continues beyond the specified period. You will receive notifications if 'Deactivate e-mail' or 'Deactivate SMS' is set to the value 'Off'.","sensor.rules.warning_desc":"This menu should ONLY be used, if you do NOT want to receive sms/mails in given periods.","sensor.rules.btn_update":"Update rules","sensor.rules.deactivate":"Deactivate notifications","sensor.rules.from":"From","sensor.rules.to":"To","sensor.rules.updated":"Rules updated","sensor.rules.failed":"Rules could not be updated","sensor.rules.validation_time_invalid":"Start cannot be after the end","sensor.rules.sms_col":"Deactivate SMS","sensor.rules.email_col":"Deactivate Mail","sensor.alarms.in_alarm":"This unit is in alarm!","sensor.alarms.none":"No alarms to show","sensor.alarms.fetch":"Fetch data","sensor.alarms.comment.headline":"Commen for the alarm at ","sensor.alarms.comment.confirm_delete":"Are you sure you want to delete?","sensor.alarms.comment.delete_failed":"Could not delete comment","sensor.alarms.comment.edit_failed":"Could not save comment","sensor.alarms.acknowledge_failed":"Could not acknowledge alarm","sensor.alarms.acknowledged":"Acknowledged alarm. It will not be shown in the future.","sensor.comments.none_yet":"No comments for this unit exists","sensor.comments.no_input":"Please write a comment","sensor.comments.confirm_delete":"Are you sure you want to delete?","sensor.comments.deleted":"Comment deleted","sensor.comments.updated":"Comment saved","sensor.comments.updated_failed":"Comment could not be saved","sensor.location.unknown":"Location of this unit is unknown","btn_save_comment":"Save comment","sensor.log.none_selected":"No measurements for the selected period","sensor.log.temperature_1":"Temperature 1","sensor.log.temperature_2":"Temperature 2","sensor.log.temperature":"Temperature","sensor.log.wellguard.on_time":"Runtime [min]","sensor.log.wellguard.max_on_time":"Max Runtime [min]","sensor.log.wellguard.on_count":"Count","sensor.log.wellguard.usage":"Usage [kWh]","sensor.log.wellguard.summary.on_time":"Total runtime [hours]","sensor.log.wellguard.summary.max_on_time":"Max runtime [min]","sensor.log.wellguard.summary.on_count":"Total count","sensor.log.wellguard.summary.usage":"Total usage [kWh]","sensor.log.fenceguard.voltage":"Voltage","sensor.log.summary.period":"Summarized data for the chosen period","sensor.log.summary.entries":"Individual log entries for the chosen period","sensor.log.summery.date_to":"to","sensor.images.choose_image":"Add image or PDF","sensor.images.uploaded":"File saved","sensor.images.deleted":"File deleted","sensor.image.popup.btn_delete":"Delete","sensor.image.popup.btn_download":"Download","sensor.image.popup.btn_close":"Close window","sensor.image.popup.confirm_delete":"Are you sure you want to delete this image permanently?","sensor.settings.sensor_1":"Sensor 1","sensor.settings.sensor_2":"Sensor 2","sensor.settings.temperature_limits":"Temperature limits","sensor.settings.alarm_delay":"Alarm delay","sensor.settings.calibration":"Calibration","sensor.settings.max_runtime":"Max runtime","sensor.settings.max_runtime_delay":"Max runtime delay","sensor.settings.power_off_delay":"Power off alarm delay","sensor.settings.voltage_limit":"Power alarm limit","sensor.settings.power_limits":"Power limits","sensor.settings.power_limits_delay":"Power limits delay","sensor.settings.power_max_idle":"Power max idle time","sensor.settings.hibernate_max_power":"Maximal power usage when idle","sensor.settings.digital_input_delay":"Delay on digital input","sensor.settings.digital_input_enabled":"Use digital input","sensor.settings.pulse_input":"Use pulse input","sensor.settings.pulse_input.off":"Off","sensor.settings.pulse_input.normally_closed":"Alarm if disconnected (normally closed)","sensor.settings.pulse_input.normally_open":"Alarm if connected (normally open)","sensor.settings.time_sync":"Time of synchronization","sensor.settings.wakeups":"Wakeups per week","sensor.settings.voltage":"Voltage","sensor.settings.reminder":"Resend alarm","sensor.settings.resync":"Synchronize after alarm","sensor.settings.service_interval":"Service interval (hours)","sensor.settings.servicekit_interval":"Service kit interval (hours)","sensor.settings.service_notification_enabled":"Send notification when service needed","sensor.settings.service_notification_email":"Email for notification (service)","sensor.settings.servicekit_notification_email":"Email til notification (servicekit)","sensor.settings.service_notification_email.placeholder":"Enter emails separated by space, comma or semicolon","sensor.settings.tip_seconds":"sec","sensor.settings.tip_min":"min","sensor.settings.tip_hour":"hour","sensor.settings.tip_hours":"hours","sensor.settings.btn_save":"Save settings","sensor.settings.saved":"Settings saved","sensor.settings.save_failed":"Settings could not be saved","sensor.settings.heading_service":"Service","sensor.toggle.pulse_input_settings":"Show pulse input settings","sensor.graphs.select_date":"Select date","sensor.graphs.change_date":"Refresh graph","sensor.graphs.no_data":"No data in interval","sensor.graphs.refresh":"Refresh graph","sensor.graphs.label_measured_temperature":"Measured temperature","sensor.graphs.label_measured_at":"Measurement created","sensor.graphs.axis_temperature":"Temperature °C","sensor.graphs.label_measured_usage":"Measured consumption","sensor.graphs.label_measured_voltage":"Volt","sensor.graphs.label_measured_value":"Value","sensor.graphs.axis_usage":"Consumption in kWh","sensor.graphs.axis_voltage":"kWh","sensor.graphs.legends.operation_info":"Operation Info","calendar.months_full":"January_February_March_April_May_June_Juli_August_September_October_November_December","calendar.months_short":"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec","calendar.weekdays":"Mon_Tue_Wed_Thu_Fri_Sat_Sun","label.filtering":"Filtering","label.filter.sensor":"Unit:","label.filter.period":"Period:","label.filter.date":"Date:","alarms.active":"Active alarms","alarms.previous":"Previous alarms","alarms.search_results":"Filtered alarms","alarms.no_active":"There are no active alarms.","alarms.no_search":"No alarms found with the chosen filtering","alarms.failed_fetching_active":"Could not fetch information about active alarms","alarms.failed_fetching_search":"Coult not fetch data","alarms.btn_print":"Print","alarms.btn_export_csv":"Export to CSV","alarms.btn_acknowledge":"Acknowledge and remove","select_all":"- All -","select_units_choose_all":"Select all","select_units_not_chosen":"Available units","select_units_chosen":"Selected units","select_error_fetching_units":"Could not fetch list of units","report.title":"Temperature report","report.btn_fetch":"Fetch data","report.btn_print":"Print","report.comment":"Comment","report.no_alarms":"No alarms.","report.choose_least_one":"Please choose at least one sensor","report.could_not_fetch_for_sensor":"Could not fetch measurement for sensor","contacts.none":"You do not have any contacts defined yet.","contacts.title":"Contacts","contacts.title_edit":"Edit contact","contacts.confirm_delete":"Are you sure you want to delete this contact?","btn_save_information":"Save information","contacts.deleted":"Contact deleted","contacts.saved":"Information saved","contacts.wizard.title_basic":"Basic information","contacts.wizard.title_units":"Receive alarms from units","contacts.wizard.menu_info":"Contact","contacts.wizard.menu_units":"Alarms","contacts.wizard.units_desc":"Please choose the units the contact should receive alarms from. This can also be done later.","contacts.title_assign":"Assign alarm receiver","contacts.btn_assign":"Assign","contacts.assigned":"Alarm receiver assigned to the unit","profile.chose_country":"- Please choose -","profile.saved":"Information saved","profile.pwd_saved":"Password changed","profile.title":"Profile for","profile.title_change_your_pwd":"Change your password","profile.title_change_other_pwd":"Change password for","profile.title_delete":"Delete account","profile.warn_delete_desc":"You are about to delete your account. Any sensors and data will be destroyed. Your contact info will be stored in accordance with the Danish Accounting Act. This process is irreversible.","profile.confirm_deletion_before_account_name":"Do you want to delete all data associated with the account ","profile.confirm_deletion_after_account_name":"?","profile.msg_sensors_exists":"You need to remove all your sensors before deleting your profile","profile.deleted":"Account deleted","country.belgium":"Belgium","country.bulgaria":"Bulgaria","country.cyprus":"Cyprus","country.denmark":"Denmark","country.farao_islands":"Farao islands","country.greenland":"Greenland","country.estonia":"Estonia","country.finland":"Finland","country.france":"France","country.greece":"Greece","country.ireland":"Ireland","country.island":"Island","country.italy":"Italy","country.latvia":"Latvia","country.lithuania":"Lithuania","country.luxembourg":"Luxembourg","country.malta":"Malta","country.netherlands":"Netherlands","country.norway":"Norway","country.poland":"Poland","country.portugal":"Portugal","country.romania":"Romania","country.switzerland":"Switzerland","country.slovakia":"Slovakia","country.slovenia":"Slovenia","country.spain":"Spain","country.united_kingdom":"United_kingdom","country.sweden":"Sweden","country.czech_republic":"Czech republic","country.germany":"Germany","country.hungary":"Hungary","country.usa":"USA","country.austria":"Austria","country.canada":"Canada","country.tunisia":"Tunisia","contacts.create.success":"The contact was sucessfully created","contacts.create.success_with_units":"Contact created and assigned units","contacts.create.failed_with_units":"The contact was created but could not be assigned to the units","users.wizard.title_account":"Account","users.wizard.title_basic":"Basic information","users.wizard.title_permissions":"Permissions","users.wizard.full_access":"Will give the user full access to all units and accounts","users.wizard.tier1_user":"Administrator (restricted to SensorCLIP)","users.wizard.tier2_user":"Super user","users.wizard.tier3_user":"Regular user","users.wizard.tier3_assigned":"assigned","users.wizard.msg_created":"The user was created","users.wizard.msg_failed":"User could not be created","users.wizard.msg_email_used":"The mail-address is already in use","warning":"WARNING","permissions.title":"User permissions","permissions.only_edit_new":"Can only be changed when creating new user","permissions.sensor_view_extra":"Can see extra sensor if unit supports","permissions.user_manage_everybody":"Can see all accounts regardless of owner","permissions.user_manage_children":"Can see subaccounts","permissions.sensor_edit":"Can configure units","permissions.comment_manage":"Can see and create comments for others","permissions.service_edit":"Can see the Service tab and report service inspections","permissions.payment":"Payment method","permissions.payment_card":"Card","permissions.payment_invoice":"Invoice","permissions.payment_requisition":"Requisition","permissions.payment_none":"Admin (no payment)","permissions.monitor_view":"Keep user logged in, when watching sensor list","permissions.msg_updated":"Permissions updated","permissions.msg_failed":"Could not update permissions!","login.attach.title":"Attach subaccount","login.attach.desc":"Here you have the possibility to attach a subaccount to your own user. This will give you permanent access over the subaccount and the corresponding units. To verify this binding you have to provide the subaccounts credentials.","login.attach.btn_assign":"Attach","login.attach.msg_error_use_subaccount_email":"This should be the subaccounts mail-address - not yours","login.attach.msg_assigned":"The account is now permanently accessable from your account","login.attach.msg_error":"Subaccount could not be attached!","login.attach.msg_wrong_credentials":"Username or password of subaccount is not correct","login.attach.msg_already_access":"You already have access to this subaccount","login.detach.title":"Remove access to subaccount","login.detach.desc":"Here you can remove an subaccount from your dashboard. This means you will no longer be able to access or configure the target account. However you can always reattach the account to regain access. All sensors and settings on the subaccount will not be changed.","login.detach.msg_error":"Subaccount could not be detached!","login.detach.msg_success":"Access to the chosen subaccount has been revoked","login.detach.btn_detach":"Detach","activity.title":"Activity log","activity.action":"Action","activity.subject":"Reference","activity.author":"Performed by","activity.btn_details":"Details","activity.change_key":"Key","activity.change_old":"Previous","activity.change_new":"New","configure.wizard.contacts.menu_sensors":"Units","configure.wizard.contacts.menu_contacts":"Alarm recipients","configure.wizard.contacts.title":"Assign alarm recipients to multiple units","configure.wizard.contacts.title_contacts":"Choose recipients","configure.wizard.contacts.desc":"Here you can assign alarm recipients / contacts to multiple units at the same time. They will not remove existing recipients, but only append to the list of recipients.","configure.wizard.contacts.desc_contacts_double":"You have the possibility to assign alarm recipients for both sensor 1 and sensor 2 for each unit, if the unit supports it. Please note you cannot remove alarm recipients here but only register new recipients here.","configure.wizard.contacts.desc_contacts":"Your selected units will get all the chosen alarm recipients attached in addition to the existing alarm recipients.","configure.wizard.contacts.sensor1":"Sensor 1","configure.wizard.contacts.sensor2":"Sensor 2","configure.wizard.contacts.validation_need_sensor":"Please choose at least one unit","configure.wizard.contacts.validation_need_contact":"Please choose at least one alarm recipient / contact person","configure.wizard.contacts.working_desc":"Saving your alarm recipients. You can follow the process below.","configure.wizard.contacts.msg_error_specific_contact":"It was not possible to register for alarms for the contact ","configure.wizard.contacts.msg_success_some":"One or more contacts were attached as alarm recipients","configure.wizard.contacts.msg_success_all":"All chosen contacts were successfully registered as alarm recipients","menu.conf_contacts":"Assign recipients","activate.title_new":"Add unit","activate.title_assigned":"Activate unit","activate.btn_save":"Save information","activate.label_requisition":"Requisition number","activate.label_user":"Assign user","activate.no_action":"Please choose a subscription if you want to activate the unit now","activate.msg_attached":"Unit is now attached to the specified user account","activate.msg_activated":"Unit activated","activate.msg_failed_activate":"Could not activate unit","activate.wizard.tab_unit":"Unit","activate.wizard.tab_subscription":"Subscription","activate.wizard.tab_terms":"Terms","activate.wizard.tab_payment":"Payment","activate.wizard.title_info":"Information","activate.wizard.title_subscription":"Choose Subscription","activate.wizard.desc_subscription":"We only offer the full experience with everything included. You only have to worry about the length of your subscription. Read more about whats included on <a href='http://sensorclip.dk/simkort' target='_blank' class='highlight-link'>our website</a>. All prices are including Danish VAT.","activate.wizard.btn_approve_terms":"Approve terms and conditions","activate.wizard.price_ex_vat":"Total price in DKK ex. VAT","activate.wizard.price_in_vat":"Total price in DKK inc. VAT","activate.wizard.vat_dkk":"25% VAT, DKK","activate.wizard.terms":"Terms and conditions","activate.wizard.terms_read_accepted":"I have read and accept","activate.wizard.terms_accepted_link":"the terms and conditions","activate.wizard.error_terms_required":"Terms must be accepted","activate.wizard.title_payment":"Payment","activate.wizard.desc_payment_invoice":"Payment is by invoice. We will activate the unit as soon as you click Confirm below. An invoice will be sent to","activate.wizard.desc_payment_card":"You are now leaving our site to go through payment. We will activate the unit when payment is completed. You will also receive a receipt on mail.","activate.wizard.choice.later":"Decide later","activate.wizard.choice.1month":"1 month for 59 DKK","activate.wizard.choice.3months":"3 months for 169 DKK, 5% discount","activate.wizard.choice.6months":"6 months for 321 DKK, 10% discount","activate.wizard.choice.12months":"12 months for 570 DKK, 20% discount","activate.wizard.choice.24months":"24 months for 998 DKK, 30% discount","activate.wizard.error_need_billing_info":"You need to update your account with billing information before proceeding","activate.wizard.manual_activation_required":"Manual activation is required, as described for your region at https://sensorclip.dk/en/solutions/prices. Please contact SensorCLIP for help.","payment.status.msg_failed_fetching_status":"Could not show status of activation. Payment is being processed in the background and the unit will be visible on your dashboard once completed. You can leave this page now","payment.status.cancelled":"Payment and activation cancelled. Please try again if this was not on purpose","payment.status.title_approved_awaiting":"Payment submitted - awaiting approval","payment.status.title_completed":"Payment completed - unit activated","payment.status.desc_completed":"Your payment has been accepted and your unit activated. The new activated unit will be visible on your dashboard within the next few minutes.","payment.status.desc_awaiting":"Awaiting system approval of your payment. This can take a couple of minutes after which your unit will be activated automatically. You can leave this page now or stay and observe the status.","pagination.showing":"Showing row ","pagination.out_of":" of ","units.table.btn_activate":"Activate permanently","units.table.btn_deactivate":"Deactivate","units.table.btn_remove":"Delete","units.table.confirm_activate":"You will have to manually send an invoice to customer. \n\nContinue?","units.table.confirm_deactivate":"Units will be deactivated but still remain on the owners list. All remaining subscription time will be lost. \n\nContinue?","units.table.confirm_remove":"Units will be removed permanently from the owners account?","units.table.msg_no_selection":"Please choose at least one unit","units.table.confirm_reload":"Actions completed. You can see the result in the row for each sensor. \n\nDo you want to reload the list to show the changes?","units.table.column_simcard":"IMEI / ICCID / PIN","units.table.column_simcard_without_imei":"ICCID / PIN","fleetmap.title":"Map over units","fleetmap.checkboxes.show_in_alarm":"Show - Alarm","fleetmap.checkboxes.show_need_service":"Show - Service","fleetmap.checkboxes.show_not_in_alarm":"Show - OK","sensor.service.texts.history":"Previous service inspections:","sensor.service.dialogs.create_inspection.title":"Name of technician","sensor.service.dialogs.reset_stats.title":"Confirm reset","sensor.service.dialogs.reset_stats.text":"Are you sure you want to reset the runtime?","sensor.service.reset_stats.msg_completed":"The information was reset","sensor.service.reset_stats.msg_failed":"Could not reset runtime","sensor.service.tables.summary.last_service_datetime":"Last service","sensor.service.tables.summary.next_service":"Next service","sensor.service.tables.summary.runtime_since_last":"Runtime since last service","sensor.service.tables.summary.actions.order_service_kit":"Order service kit","sensor.service.tables.summary.actions.create_inspection":"Service completed","sensor.service.tables.history.column_technician":"Technician","sensor.service.tables.history.column_runtime_total":"Total runtime [hours]","sensor.service.tables.history.column_runtime_since_last":"Total runtime at service [hours]","sensor.service.headlines.settings":"Settings","sensor.service.headlines.summary":"Summary","sensor.service.headlines.history":"History","sensor.service.last_service_unknown":"No data","sensor.service.settings.btn_add_more":"Add another","firmware.upload.title":"Firmware Versions","firmware.upload.description":"Upload firmware for the SC200 serie.","btn_firmware_upload":"Upload and overwrite","firmware.upload.placeholder_file":"Chose file","firmware.upload.placeholder_drop":"Drag and drop file here","firmware.upload.msg_no_file_chosen":"Please select a file","firmware.upload.msg_saved":"Firmware uploaded","firmware.upload.msg_save_failed":"Firmware could not be uploaded. Please check the file is a valid firmware","firmware.table.btn_refresh_list":"Reload","firmware.table.btn_update":"Update selected","firmware.table.btn_update_cancel":"Cancel update","firmware.table.confirm_update":"Update unit next time it comes online?","firmware.table.confirm_update_cancel":"Cancel planned update for the selected units?","firmware.history.title":"Firmware Versions","firmware.history.table.column_created":"Uploaded","firmware.history.table.column_name":"File","firmware.history.table.column_checksum":"Checksum","firmware.history.table.empty":"No versions registered.","firmware_updates.table.completed.column_firmware":"Version","firmware_updates.table.completed.column_requested":"Planned","firmware_updates.table.completed.column_downloaded":"Downloaded","firmware_updates.panel.pending.title":"Planned updates","firmware_updates.panel.completed.title":"Completed updates","firmware_updates.panel.pending.desc":"These units will update on their next connection","firmware_updates.table.pending.column_original_fw":"Old Firmware","firmware_updates.table.pending.column_current_fw":"Current Firmware","firmware_updates.table.pending.column_downloaded":"Downloaded","firmware_updates.table.pending.column_requested":"Requested","firmware_updates.table.pending.title_last_download":"Last download: "}

/***/ }),

/***/ "QZsj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("KlCj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b1205c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("DXda");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b1205c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    api_server:  true ? "/api/v1" : "http://sensor-api/v1",
    app_id: "mdevelopment-vue",
    app_secret: "12345", // @TODO: Not to be defined here. Use proxy for login instead
    maps_key: "AIzaSyCW3qNQ50GTWSe6VRr6PMCC559zmOMrkrw",
    maps_id: "5afc08023391ec6d"
});

/***/ }),

/***/ "TDlp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_messages_vue__ = __webpack_require__("NQPl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21a0ba8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_messages_vue__ = __webpack_require__("Hy2l");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_messages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21a0ba8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_messages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TFOn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.validate),expression:"validate"}],class:{'is-invalid': _vm.errors.has(_vm.name) },attrs:{"value":_vm.value,"type":_vm.type,"name":_vm.name,"placeholder":_vm.placeholder,"data-vv-as":_vm.alias,"disabled":_vm.disabled},on:{"input":_vm.updateValue}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.name)),expression:"errors.has(name)"}],staticClass:"help is-invalid"},[_vm._v(_vm._s(_vm.errors.first(_vm.name)))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TIfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user__ = __webpack_require__("DxRk");

// Cookie handling:
// https://www.npmjs.com/package/vue-cookie





var cookie = __webpack_require__("K/Lq");

/* harmony default export */ __webpack_exports__["a"] = ({
    login: function login(username, data) {

        var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__user__["a" /* getUserFromLoginObject */])(data);
        user.email = username;
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit("login", user);

        cookie.set("token", 'Token ' + data.token);
        cookie.set("user", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user));
        cookie.set("token_expires", data.expires);

        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/");
    },

    logout: function logout() {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch("logout");

        cookie.delete('token');
        cookie.delete('user');
        cookie.delete('context');
        cookie.delete('token_expires');

        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/");
    },

    restore: function restore() {
        try {

            var auth = cookie.get('token');
            var user = cookie.get('user');
            var lang = cookie.get('lang');
            var expires = cookie.get('token_expires');

            if (lang && lang.length === 2) __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch("setLanguage", lang);

            if (this.isInFuture(expires)) {
                if (user && auth) {
                    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit("restore", JSON.parse(user));

                    // Restore context
                    var context = cookie.get('context');
                    var parsedContext = context ? JSON.parse(context) : false;

                    if (parsedContext && parsedContext['id'] > 0) __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit("setContext", parsedContext);
                }
            }
        } catch (error) {
            return;
        }
    },

    getAuthHeader: function getAuthHeader() {
        return cookie.get('token');
    },

    isInFuture: function isInFuture(token) {
        var date = new Date(token);
        var now = new Date();
        return now <= date;
    }
});

/***/ }),

/***/ "TXdf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U+4G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['items']
});

/***/ }),

/***/ "U6DU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export canAccessRoute */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canAccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMenuItems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes__ = __webpack_require__("KWv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");




var canAccessRoute = function canAccessRoute(route) {

    return route.meta.permissions.every(canAccess);
};

var hasContextPermission = function hasContextPermission(perm) {
    if (perm === "exists") {
        return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getContextUser !== null;
    }

    return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.hasContextPermission(perm);
};

var hasMixedPerm = function hasMixedPerm(perm) {
    if (isContextPerm(perm)) {
        // Context permission?
        return hasContextPermission(perm.substring(8));
    } else {
        // Regular permission
        return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.hasPermission(perm);
    }
};

var isContextPerm = function isContextPerm(perm) {
    return perm.substring(0, 8) === "context_";
};

var canAccess = function canAccess(exp) {
    if (!Array.isArray(exp)) return hasMixedPerm(exp);

    var op = exp[0];
    if (op === 'or') return hasAny(exp.slice(1));else if (op === 'not' && exp.length === 2) return !canAccess(exp[1]);else return hasAll(exp);
};

var hasAny = function hasAny(list) {
    return list.some(canAccess);
};

var hasAll = function hasAll(list) {
    return list.length > 0 && list.every(canAccess);
};

var getMenuItems = function getMenuItems() {
    var filtered = [];
    var index = -1;
    for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_1__routes__["a" /* routes */].length; i++) {
        if (canAccessRoute(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* routes */][i])) {
            var _routes$i = __WEBPACK_IMPORTED_MODULE_1__routes__["a" /* routes */][i],
                submenu = _routes$i.submenu,
                route = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_routes$i, ["submenu"]);

            filtered[++index] = route;

            if (submenu) {
                filtered[index].submenu = [];

                for (var x = 0; x < submenu.length; x++) {
                    if (canAccessRoute(submenu[x])) {
                        filtered[index].submenu.push(submenu[x]);
                    }
                }
            }
        }
    }

    return filtered;
};


/***/ }),

/***/ "UQJ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18b1a3e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_links_vue__ = __webpack_require__("4d9x");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18b1a3e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_links_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Uikz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav navbar-nav"},_vm._l((_vm.routes),function(route){return _c('router-link',{key:route.meta.label,staticClass:"nav-item",attrs:{"to":{name: route.name},"role":"button","active-class":"open","aria-expanded":"false","tag":"li","exact":""}},[_c('a',{staticClass:"nav-link",class:{'hidden': route.meta.noLabel}},[_c('span',{class:'icon ' + route.meta.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(route.meta.label)))])]),_vm._v(" "),(route.submenu)?_c('submenu',{attrs:{"items":route.submenu}}):_vm._e()],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAuthenticated", function() { return isAuthenticated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPermissions", function() { return getPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasPermission", function() { return hasPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUser", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSensors", function() { return getSensors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContacts", function() { return getContacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFirmwareHistory", function() { return getFirmwareHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContact", function() { return getContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAlertingContacts", function() { return getAlertingContacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAlertingContact", function() { return getAlertingContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContextUser", function() { return getContextUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContextPermissions", function() { return getContextPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasContextPermission", function() { return hasContextPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasTargetContextPermission", function() { return hasTargetContextPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTargetContext", function() { return getTargetContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContextPath", function() { return getContextPath; });

var isAuthenticated = function isAuthenticated(state) {
    return state.user != null && state.user.id > 0;
};

var getPermissions = function getPermissions(state, getters) {
    var user = getters.getUser;

    return user === null ? {} : state.user.permissions;
};

var hasPermission = function hasPermission(state, getters) {
    return function (permission) {
        var perms = getters.getPermissions;

        return perms.hasOwnProperty(permission) && perms[permission] === true;
    };
};

var getUser = function getUser(state, getters) {
    return getters.isAuthenticated ? state.user : null;
};

var getSensors = function getSensors(state, getters) {
    return getters.isAuthenticated ? state.sensors : null;
};

var getContacts = function getContacts(state, getters) {
    return getters.isAuthenticated ? state.contacts : null;
};

var getFirmwareHistory = function getFirmwareHistory(state, getters) {
    return state.firmware_versions;
};

var getContact = function getContact(state, getters) {
    return function (id) {
        return getters.isAuthenticated ? state.contacts.find(function (contact) {
            return contact.id === id;
        }) : null;
    };
};

var getAlertingContacts = function getAlertingContacts(state, getters) {
    return getters.isAuthenticated ? state.alerting_contacts : null;
};

var getAlertingContact = function getAlertingContact(state, getters) {
    return function (id) {
        return getters.isAuthenticated ? state.alerting_contacts.find(function (contact) {
            return contact.id === id;
        }) : null;
    };
};

var getContextUser = function getContextUser(state, getters) {
    return getters.isAuthenticated ? state.context : null;
};

var getContextPermissions = function getContextPermissions(state, getters) {
    var user = getters.getContextUser;
    return user !== null ? user.permissions : {};
};

var hasContextPermission = function hasContextPermission(state, getters) {
    return function (permission) {
        var perms = getters.getContextPermissions;

        return perms.hasOwnProperty(permission) && perms[permission] === true;
    };
};

var hasTargetContextPermission = function hasTargetContextPermission(state, getters) {
    return function (permission) {
        var perms = getters.getTargetContext.permissions;

        return perms.hasOwnProperty(permission) && perms[permission] === true;
    };
};

var getTargetContext = function getTargetContext(state, getters) {
    return getters.getContextUser || getters.getUser;
};

var getContextPath = function getContextPath(state, getters) {
    return getters.isAuthenticated ? state.contextPath : [];
};

/***/ }),

/***/ "UmPW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XyYb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mainmenu_vue__ = __webpack_require__("kkj5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a46802e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mainmenu_vue__ = __webpack_require__("Uikz");
function injectStyle (ssrContext) {
  __webpack_require__("TXdf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mainmenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a46802e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mainmenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__("KWv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions__ = __webpack_require__("U6DU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_messages__ = __webpack_require__("sw1b");
/* unused harmony reexport canAccess */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__functions__["b"]; });






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* routes */],
    hashbang: false,
    mode: 'history'
});

// Authenticate routes here (RouteGuard)
router.beforeResolve(function (to, from, next) {
    if (to.matched.some(function (record) {
        return record.meta.authEmployee;
    })) {
        console.log("Requires Employee!");
        alert("Du har desværre ikke adgang til denne side. Det er kun for medarbejdere.");
    } else if (to.matched.some(function (record) {
        return record.meta.authAdmin;
    })) {
        console.log("Requires admin!");
        alert("Du har desværre ikke adgang til denne side. Administrator rettigheder påkrævet.");
    } else {
        next(); // make sure to always call next()!
    }
});

router.afterEach(function (to, from) {
    __WEBPACK_IMPORTED_MODULE_4__utils_messages__["d" /* default */].clear();
});



/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Ys3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "panel",
    props: ["title", "subtitle"],
    computed: {
        hasToolsSlot: function hasToolsSlot() {
            return !!this.$slots['tools'];
        }
    }
});

/***/ }),

/***/ "Z53w":
/***/ (function(module, exports) {

module.exports = {"login.btn_create_account":"Konto erstellen","login.btn_login":"Einloggen","login.btn_reset_pwd":"Passwort zurücksetzen","login.create.title":"Konto erstellen","login.create.desc":"Um das Bedienfeld zu verwenden, sollten Sie ein SensorCLIP-Gerät erworben haben. Sie können sich hier immer anmelden und das Gerät später hinzufügen.","login.create.confirm_back":"Bist du sicher, dass du anhalten und zurückgehen willst?","login.create.email_in_use":"Die angegebene E-Mail wird bereits verwendet.","login.create.generic_error":"Überprüfen Sie Ihre Informationen unten oder wenden Sie sich an den Support","login.forgotten.title":"Passwort vergessen?","login.forgotten.desc":"Wenden Sie sich an unseren Support, um Unterstützung beim Zugriff auf Ihr Konto zu erhalten. Sie finden unsere Kontaktinformationen über den folgenden Link:","processing":"Bitte warten","label.email":"E-Mail","label.name":"Name","label.password":"Passwort","btn_back":"Zurück","btn_cancel":"Stornieren"}

/***/ }),

/***/ "aPSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__("rKsW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),

/***/ "broi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user__ = __webpack_require__("DxRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__register_vue__ = __webpack_require__("5zCw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__recover_vue__ = __webpack_require__("J5b6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_snippets_language_switcher_vue__ = __webpack_require__("BHyr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_cookie__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    components: { panelRegister: __WEBPACK_IMPORTED_MODULE_3__register_vue__["a" /* default */], panelRecover: __WEBPACK_IMPORTED_MODULE_4__recover_vue__["a" /* default */], languageSwitcher: __WEBPACK_IMPORTED_MODULE_5__layout_snippets_language_switcher_vue__["a" /* default */] },
    name: 'login',
    data: function data() {
        return {
            error: "",
            username: "",
            password: "",
            working: false,
            justRegistered: false,
            container: "login"
        };
    },

    computed: {
        isWorking: function isWorking() {
            return this.working;
        },
        sessionTimeout: function sessionTimeout() {
            var expiration = __WEBPACK_IMPORTED_MODULE_6_vue_cookie___default.a.get("token_expires");

            if (expiration !== null) {
                return !__WEBPACK_IMPORTED_MODULE_0__utils_auth__["a" /* default */].isInFuture(expiration);
            }
            return false;
        }
    },
    methods: {
        setContainer: function setContainer(target) {
            this.error = "";
            this.justRegistered = false;
            this.container = target;
        },
        displayError: function displayError(event) {
            this.error = event.message;
        },
        handleNewlyRegistered: function handleNewlyRegistered(event) {
            this.username = event.email;
            this.password = event.password;
            this.setContainer("login");
            this.justRegistered = true;
            this.handleLogin();
        },
        handleLogin: function handleLogin() {
            var _this = this;

            this.error = "";

            // Validate empty input
            if (this.username.trim().length == 0 || this.password.trim().length == 1) {
                this.error = "Udfyld venligst alle felter";
                return;
            }

            this.working = true;
            this.$rest.post("token", {
                application: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].app_id,
                application_secret: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].app_secret,
                username: this.username,
                password: this.password
            }).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_0__utils_auth__["a" /* default */].login(this.username, response.data);
            }.bind(this)).catch(function (error) {
                if (error.response) {
                    if (error.response.data.type === "UnauthenticatedClient") this.error = "Forkert brugernavn eller adgangskode";else this.error = error.response.data.message;
                } else {
                    this.error = "Der opstod en fejl og du kunne ikke logges på";
                }
                this.$store.commit("failedLogin");
            }.bind(this)).finally(function () {
                _this.justRegistered = false;
                _this.working = false;
            });
        }
    }
});

/***/ }),

/***/ "cbh6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center",style:(_vm.outerstyles)},[_c('div',{staticClass:"spinner spinner--rotate-square-2",style:(_vm.styles)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dCB4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back panel"},[_c('form',{attrs:{"action":"#","id":"forgot_password_form","method":"post","novalidate":"novalidate"}},[_c('h4',[_vm._v(_vm._s(_vm.$t('login.forgotten.title')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',[_vm._v(_vm._s(_vm.$t('login.forgotten.desc'))+" ")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-footer"},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn pull-right btn-space",attrs:{"type":"button","href":"#","tabindex":"7"},on:{"click":_vm.confirmBack}},[_c('i',{staticClass:"icon-caret-left"}),_vm._v("\n                "+_vm._s(_vm.$t('btn_back'))+"\n            ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('p',[_c('a',{attrs:{"href":"http://www.sensorclip.dk/kontakt","target":"_blank"}},[_vm._v("http://www.sensorclip.dk/kontakt")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn pull-right",staticStyle:{"display":"none"},attrs:{"name":"submitLogin","type":"submit","tabindex":"6"}},[_c('i',{staticClass:"icon-ok text-success"}),_vm._v("\n                Send e-mail\n            ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dxxY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topbar_vue__ = __webpack_require__("DoXa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51d061ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_topbar_vue__ = __webpack_require__("3ATp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51d061ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_topbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eEvK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_usermenu_vue__ = __webpack_require__("MJyD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdb21ee8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_usermenu_vue__ = __webpack_require__("rHUJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_usermenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdb21ee8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_usermenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eoiY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchActiveAlarms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateAlarmRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");


var fetchActiveAlarms = function fetchActiveAlarms(_ref) {
    var state = _ref.state,
        commit = _ref.commit;

    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$rest.get("/user/" + state.user.id + "/active-alarms").then(function (content) {
        //commit("setAlarms", content.data)
        console.log(content.data);
    });
};

// Alarm rules
var updateAlarmRules = function updateAlarmRules(_ref2, _ref3) {
    var state = _ref2.state,
        commit = _ref2.commit;
    var serial = _ref3.serial,
        rules = _ref3.rules;

    var data = [];

    for (var i = 0; i < rules.length; i++) {
        data[i] = {
            weekday: i,
            to: [rules[i].to.HH, rules[i].to.mm, "00"].join(":"),
            from: [rules[i].from.HH, rules[i].from.mm, "00"].join(":"),
            phone_enabled: rules[i].sms,
            email_enabled: rules[i].email
        };
    }

    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$rest.post("/sensor/" + serial + "/alarm-rules", { rules: data });
};

/***/ }),

/***/ "fcFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__("qRo1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),

/***/ "hlGR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchContacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateContact; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");



var fetchContacts = function fetchContacts(_ref) {
    var commit = _ref.commit,
        getters = _ref.getters;

    return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$rest.get("/user/" + getters.getTargetContext.id + "/contact").then(function (content) {
        commit("setContacts", content.data);
    });
};

var fetchContact = function fetchContact(_ref2) {
    var getters = _ref2.getters,
        commit = _ref2.commit;

    return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$rest.get("/user/" + getters.getTargetContext.id + "/contact").then(function (content) {
        commit("setContacts", content.data);
    });
};

var deleteContact = function deleteContact(_ref3, id) {
    var getters = _ref3.getters,
        commit = _ref3.commit;

    return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$rest.delete("/user/" + getters.getTargetContext.id + "/contact/" + id).then(function (content) {
        commit("removeContact", id);
    });
};

var updateContact = function updateContact(_ref4, contact) {
    var getters = _ref4.getters,
        commit = _ref4.commit;

    var id = contact.id,
        data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(contact, ["id"]);

    return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$rest.put("/user/" + getters.getTargetContext.id + "/contact/" + id, data).then(function (content) {
        commit("updateContact", contact);
    });
};

/*export const assignContact = ({getters, commit}, contact, sensor) => {
    let {id, ...data} = contact;

    return Vue.prototype.$rest.put("/user/" + getters.getTargetContext.id + "/contact/" + id, data).then(function (content) {
        commit("updateContact", contact)
    })
};*/



/***/ }),

/***/ "hssj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchAlertingContacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteAlertingContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createAlertingContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateAlertingContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toggleAlertingContactStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("/5sW");




var fetchAlertingContacts = function fetchAlertingContacts(_ref) {
    var commit = _ref.commit,
        getters = _ref.getters;

    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$rest.get("/user/" + getters.getTargetContext.id + "/alerting").then(function (content) {
        commit("setAlertingContacts", content.data);
    });
};

var deleteAlertingContact = function deleteAlertingContact(_ref2, id) {
    var getters = _ref2.getters,
        commit = _ref2.commit;

    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$rest.delete("/user/" + getters.getTargetContext.id + "/alerting/" + id).then(function (content) {
        commit("removeAlertingContact", id);
    });
};

var createAlertingContact = function createAlertingContact(_ref3, contact) {
    var getters = _ref3.getters,
        commit = _ref3.commit;

    var id = contact.id,
        data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(contact, ["id"]);

    data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { active: true });

    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$rest.post("/user/" + getters.getTargetContext.id + "/alerting", data).then(function (content) {
        commit("updateAlertingContact", contact);
    });
};

var updateAlertingContact = function updateAlertingContact(_ref4, contact) {
    var getters = _ref4.getters,
        commit = _ref4.commit;

    var id = contact.id,
        data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(contact, ["id"]);

    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$rest.put("/user/" + getters.getTargetContext.id + "/alerting/" + id, data).then(function (content) {
        commit("updateAlertingContact", contact);
    });
};

var toggleAlertingContactStatus = function toggleAlertingContactStatus(_ref5, _ref6) {
    var getters = _ref5.getters,
        commit = _ref5.commit;
    var contact = _ref6.contact,
        enable = _ref6.enable;
    var id = contact.id;

    var data = { active: enable };

    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$rest.patch("/user/" + getters.getTargetContext.id + "/alerting/" + id, data).then(function (content) {
        commit("updateAlertingContact", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, contact, { active: enable }));
    });
};

/*export const assignContact = ({getters, commit}, contact, sensor) => {
    let {id, ...data} = contact;

    return Vue.prototype.$rest.put("/user/" + getters.getTargetContext.id + "/contact/" + id, data).then(function (content) {
        commit("updateContact", contact)
    })
};*/

/***/ }),

/***/ "k0Yb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kJiG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__("9NuQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),

/***/ "kkj5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__submenu_vue__ = __webpack_require__("KHRN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        submenu: __WEBPACK_IMPORTED_MODULE_2__submenu_vue__["a" /* default */]
    },
    computed: {
        routes: {
            get: function get() {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__router_index__["b" /* getMenuItems */])().filter(function (route) {
                    return route.meta.inMainmenu;
                });
            }
        }
    },
    methods: {
        handleLogout: function handleLogout() {
            __WEBPACK_IMPORTED_MODULE_1__utils_auth__["a" /* default */].logout();
        }
    }
});

/***/ }),

/***/ "m76j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"mai-nav-tabs-sub mai-sub-nav nav"},_vm._l((_vm.items),function(route){return _c('router-link',{key:route.meta.label,staticClass:"nav-item dropdown",attrs:{"to":{name: route.target},"role":"button","active-class":"open","aria-expanded":"false","tag":"li","exact":""}},[_c('a',{staticClass:"nav-link"},[_c('span',{class:'icon ' + route.meta.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(route.meta.label)))])])])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_contacts__ = __webpack_require__("hlGR");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "fetchContacts", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_contacts__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "fetchContact", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_contacts__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "deleteContact", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_contacts__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "updateContact", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_contacts__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_alarms__ = __webpack_require__("eoiY");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "fetchActiveAlarms", function() { return __WEBPACK_IMPORTED_MODULE_1__actions_alarms__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "updateAlarmRules", function() { return __WEBPACK_IMPORTED_MODULE_1__actions_alarms__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_alerting__ = __webpack_require__("hssj");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "fetchAlertingContacts", function() { return __WEBPACK_IMPORTED_MODULE_2__actions_alerting__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "deleteAlertingContact", function() { return __WEBPACK_IMPORTED_MODULE_2__actions_alerting__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "createAlertingContact", function() { return __WEBPACK_IMPORTED_MODULE_2__actions_alerting__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "updateAlertingContact", function() { return __WEBPACK_IMPORTED_MODULE_2__actions_alerting__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "toggleAlertingContactStatus", function() { return __WEBPACK_IMPORTED_MODULE_2__actions_alerting__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_sensors__ = __webpack_require__("8Rax");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "updateSensorSettings", function() { return __WEBPACK_IMPORTED_MODULE_3__actions_sensors__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "deactivateSensor", function() { return __WEBPACK_IMPORTED_MODULE_3__actions_sensors__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "removeSensor", function() { return __WEBPACK_IMPORTED_MODULE_3__actions_sensors__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_context__ = __webpack_require__("H9j1");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "updateContext", function() { return __WEBPACK_IMPORTED_MODULE_4__actions_context__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_login__ = __webpack_require__("/Iwc");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "logout", function() { return __WEBPACK_IMPORTED_MODULE_5__actions_login__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_lang__ = __webpack_require__("Hh2S");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setLanguage", function() { return __WEBPACK_IMPORTED_MODULE_6__actions_lang__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_firmware__ = __webpack_require__("Dy+K");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "overwriteFirmware", function() { return __WEBPACK_IMPORTED_MODULE_7__actions_firmware__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "fetchFirmwareHistory", function() { return __WEBPACK_IMPORTED_MODULE_7__actions_firmware__["b"]; });









/***/ }),

/***/ "pMIF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back panel"},[(!_vm.loading)?_c('form',{attrs:{"id":"register_form"},on:{"submit":function($event){$event.preventDefault();return _vm.attemptRegister($event)}}},[(_vm.error)?_c('div',{staticClass:"alert alert-danger",attrs:{"id":"error"}},[_vm._v("\n            "+_vm._s(_vm.error)+"\n        ")]):_vm._e(),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('login.create.title')))]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.$t('login.create.desc'))+"\n        ")]),_vm._v(" "),_c('form-row',{attrs:{"label":_vm.$t('label.name')}},[_c('form-input',{attrs:{"validate":"required","name":"Navn","alias":_vm.$t('label.name')},model:{value:(_vm.input.name),callback:function ($$v) {_vm.$set(_vm.input, "name", $$v)},expression:"input.name"}})],1),_vm._v(" "),_c('form-row',{attrs:{"label":_vm.$t('label.email')}},[_c('form-input',{attrs:{"validate":"required|email","name":"Email","alias":_vm.$t('label.email')},model:{value:(_vm.input.email),callback:function ($$v) {_vm.$set(_vm.input, "email", $$v)},expression:"input.email"}})],1),_vm._v(" "),_c('form-row',{attrs:{"label":_vm.$t('label.password')}},[_c('form-input',{attrs:{"type":"password","validate":"required","name":"Adgangskode","alias":_vm.$t('label.password')},model:{value:(_vm.input.password),callback:function ($$v) {_vm.$set(_vm.input, "password", $$v)},expression:"input.password"}})],1),_vm._v(" "),_c('div',{staticClass:"panel-footer"},[_c('button',{staticClass:"btn pull-right",attrs:{"name":"submitLogin","type":"submit","tabindex":"6"}},[_c('i',{staticClass:"icon-ok text-success"}),_vm._v("\n                "+_vm._s(_vm.$t('login.btn_create_account'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn pull-right btn-space",attrs:{"type":"button","href":"#","tabindex":"7"},on:{"click":_vm.confirmBack}},[_c('i',{staticClass:"icon-caret-left"}),_vm._v("\n                "+_vm._s(_vm.$t('btn_back'))+"\n            ")])])],1):_vm._e(),_vm._v(" "),(_vm.loading)?_c('loader'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__("xKc6");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("u54A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rHUJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav navbar-nav float-lg-right mai-user-nav"},[_c('li',{staticClass:"dropdown nav-item",class:{open: _vm.isOpen}},[_c('a',{staticClass:"dropdown-toggle nav-link",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleMenu()}}},[_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(this.$store.state.user.name))]),_c('span',{staticClass:"angle-down s7-angle-down"}),_vm._v(" "),(_vm.overlaying)?_c('span',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.overlayUser))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"role":"menu"}},[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":{name: 'dashboard'},"active-class":"active","exact":""}},[_c('span',{staticClass:"icon s7-display1"}),_vm._v(_vm._s(_vm.$t('topmenu.my_units')))]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":{name: 'profile'},"active-class":"active"}},[_c('span',{staticClass:"icon s7-user"}),_vm._v(_vm._s(_vm.$t('topmenu.my_profile')))]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",on:{"click":function($event){return _vm.handleLogout()}}},[_c('span',{staticClass:"icon s7-power"}),_vm._v(_vm._s(_vm.$t('topmenu.logout')))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rOym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      content: 'Hello foot!'
    };
  }
});

/***/ }),

/***/ "sw1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ERROR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
// This should only be used for displaying messages (like "Item updated")

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

var SUCCESS = "success";
var INFO = "info";
var ERROR = "error";

/* harmony default export */ __webpack_exports__["d"] = ({
    success: function success(message) {
        EventBus.$emit('message', { type: SUCCESS, message: message, target: this.target });
    },

    error: function error(message) {
        EventBus.$emit('message', { type: ERROR, message: message, target: this.target });
    },

    info: function info(message) {
        EventBus.$emit('message', { type: INFO, message: message, target: this.target });
    },

    clear: function clear() {
        EventBus.$emit('message.clear');
    },

    data: function data() {
        return {
            target: null
        };
    },

    bus: EventBus
});

/***/ }),

/***/ "tOiY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login-panel"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-container"},[_c('div',{attrs:{"id":"lang"}},[_c('language-switcher')],1),_vm._v(" "),(_vm.container == 'login')?_c('div',{staticClass:"front panel"},[_c('form',{attrs:{"action":"#","id":"login_form","method":"post"}},[(_vm.error)?_c('div',{staticClass:"alert alert-danger",attrs:{"id":"error"}},[_vm._v("\n                    "+_vm._s(_vm.error)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.justRegistered)?_c('div',{staticClass:"alert alert-success"},[_vm._v("\n                    Din konto er nu oprettet. Vent venligst imens vi logger dig ind.\n                ")]):_vm._e(),_vm._v(" "),(_vm.sessionTimeout)?_c('div',{staticClass:"alert alert-info"},[_vm._v("\n                    Du er automatisk blevet logget ud.\n                ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"email"}},[_vm._v(_vm._s(_vm.$t('label.email')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-control",attrs:{"name":"email","type":"text","id":"email","value":"","autofocus":"autofocus","tabindex":"1","placeholder":"test@example.com"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                        "+_vm._s(_vm.$t('label.password'))+"\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"name":"passwd","type":"password","value":"","tabindex":"2","placeholder":"Adgangskode"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group row-padding-top"},[_c('button',{staticClass:"btn btn-primary btn-lg btn-block ladda-button btn-login",class:{disabled: _vm.isWorking},attrs:{"tabindex":"4","disabled":_vm.isWorking},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleLogin($event)}}},[(!_vm.isWorking)?_c('span',{staticClass:"ladda-label"},[_vm._v("\n                           "+_vm._s(_vm.$t('login.btn_login', 'Login'))+"\n                        ")]):_vm._e(),(_vm.isWorking)?_c('span',{staticClass:"ladda-label"},[_vm._v("\n                            "+_vm._s(_vm.$t('processing'))+"\n                        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('a',{staticClass:"show-forgfot-password pull-left",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.setContainer('register')}}},[_vm._v("\n                        "+_vm._s(_vm.$t('login.btn_create_account'))+"\n                    ")]),_vm._v(" "),_c('a',{staticClass:"show-forgfot-password pull-right",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.setContainer('recover')}}},[_vm._v("\n                        "+_vm._s(_vm.$t('login.btn_reset_pwd'))+"\n                    ")])])])]):_vm._e(),_vm._v(" "),(_vm.container == 'recover')?_c('panel-recover',{on:{"back":function($event){return _vm.setContainer('login')}}}):_vm._e(),_vm._v(" "),(_vm.container == 'register')?_c('panel-register',{on:{"back":function($event){return _vm.setContainer('login')},"registered":_vm.handleNewlyRegistered}}):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login-header"}},[_c('h1',{staticClass:"text-center"},[_vm._v("\n            SensorCLIP\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "toTE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("rOym");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1416cfac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("BJcI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1416cfac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "txGb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_snippets_form_row_vue__ = __webpack_require__("LzJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_snippets_form_input_vue__ = __webpack_require__("9yKr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        formRow: __WEBPACK_IMPORTED_MODULE_0__layout_snippets_form_row_vue__["a" /* default */],
        formInput: __WEBPACK_IMPORTED_MODULE_1__layout_snippets_form_input_vue__["a" /* default */]
    },
    computed: {
        modified: function modified() {
            return this.input.name.length + this.input.email.length + this.input.password.length > 0;
        }
    },
    data: function data() {
        return {
            error: null,
            loading: false,
            input: {
                name: "",
                email: "",
                password: ""
            }
        };
    },

    $_veeValidate: {
        validator: 'new'
    },
    methods: {
        confirmBack: function confirmBack() {
            if (!this.modified || confirm(this.$t('login.create.confirm_back'))) {
                this.$emit('back');
            }
        },
        attemptRegister: function attemptRegister() {
            this.error = "";

            // Validate
            this.$validator.validateAll().then(function (result, resolve) {
                if (!result) {
                    resolve.reject();
                }
            }).then(this.save).catch(function () {});
        },
        save: function save() {
            var _this = this;

            this.loading = true;

            this.$rest.post("/user", this.input).then(function () {
                _this.$emit('registered', { email: _this.input.email, password: _this.input.password });
            }).catch(function (request) {
                if (request.response.data && request.response.data.errors) {
                    var error = request.response.data.errors[0];
                    if (error.rule === "Unique" && error.parameter === "email") {
                        _this.error = _this.$t('login.create.email_in_use');
                        return;
                    }
                }
                _this.error = _this.$t('login.create.generic_error');
            }).finally(function () {
                _this.loading = false;
            });
        }
    }
});

/***/ }),

/***/ "u0ae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

// Source: https://github.com/nguyenvanduocit/vue-loading-spinner/
// Imported here as the source does not allow to alter the color
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        size: {
            default: '40px'
        },
        background: {
            default: '#2c7b9c'
        },
        minHeight: {
            default: '0px'
        },
        fill: {
            type: Boolean,
            default: true
        },
        center: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        styles: function styles() {
            return {
                width: this.size,
                height: this.size,
                margin: this.center ? "auto" : "0"
            };
        },
        outerstyles: function outerstyles() {
            return {
                "min-height": this.fill ? "300px" : this.minHeight
            };
        }
    }
});

/***/ }),

/***/ "u54A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sensor__ = __webpack_require__("9m5w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookie__);




/* harmony default export */ __webpack_exports__["a"] = ({
    login: function login(state, user) {
        state.user = user;
    },
    restore: function restore(state, user) {
        state.user = user;
    },
    logout: function logout(state) {
        state.user = {};
        state.contacts = [];
        state.sensors = [];
    },
    failedLogin: function failedLogin(state) {
        state.loginAttempts++;
    },
    userinfo: function userinfo(state, data) {
        state.user.info.adr1 = data.adr1;
        state.user.info.adr2 = data.adr2;
        state.user.info.adr3 = data.adr3;
        state.user.info.postcode = data.postcode;
        state.user.info.city = data.city;
        state.user.info.country = data.country;
        state.user.info.phone = data.phone;
        state.user.info.vat_number = data.vat_number;
        state.user.info.email_invoice = data.email_invoice;
    },
    contextuserinfo: function contextuserinfo(state, data) {
        if (state.context === null) return;

        state.context.info.adr1 = data.adr1;
        state.context.info.adr2 = data.adr2;
        state.context.info.adr3 = data.adr3;
        state.context.info.postcode = data.postcode;
        state.context.info.city = data.city;
        state.context.info.country = data.country;
        state.context.info.phone = data.phone;
        state.context.info.vat_number = data.vat_number;
        state.context.info.email_invoice = data.email_invoice;
    },
    setSensors: function setSensors(state, sensors) {
        if (state.sensors.length > 0) state.sensors = [];

        sensors.forEach(function (itemData) {
            state.sensors.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sensor__["a" /* fromAPIData */])(itemData));
        });

        // Sort them with the ones in alarm being first
        state.sensors.sort(function (a, b) {

            if (a.alarm) return -1;else if (b.alarm) return 1;

            return a.label.localeCompare(b.label);
        });
    },
    sensorUpdated: function sensorUpdated(state, sensor) {

        // We only care about the name
        state.sensors.forEach(function (s) {
            if (s.serial === sensor.serial) {
                s.label = sensor.label;

                if (sensor.activated !== undefined) s.activated = sensor.activated;
            }
        });
    },
    sensorRemoved: function sensorRemoved(state, sensor) {
        state.sensors = state.sensors.filter(function (s) {
            return s.serial !== sensor.serial;
        });
    },
    setContext: function setContext(state, user) {
        state.context = user;
        state.contextPath.push(user);
        __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.set('context', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user));
    },
    sliceContextPath: function sliceContextPath(state, index) {
        state.contextPath = state.contextPath.slice(0, index);
        state.context = state.contextPath[index - 1];
        __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.set('context', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.context));
    },
    clearContext: function clearContext(state) {
        state.context = null;
        state.contextPath = [];
        __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.delete('context');
    },
    setContacts: function setContacts(state, data) {
        state.contacts = data;
    },
    updateContact: function updateContact(state, contact) {
        var index = state.contacts.findIndex(function (c) {
            return c.id === contact.id;
        });
        if (index !== -1) state.contacts.splice(index, 1, contact);
    },
    removeContact: function removeContact(state, id) {
        var index = state.contacts.findIndex(function (c) {
            return c.id === id;
        });
        if (index !== -1) state.contacts.splice(index, 1);
    },
    setAlertingContacts: function setAlertingContacts(state, data) {
        state.alerting_contacts = data;
    },
    updateAlertingContact: function updateAlertingContact(state, contact) {
        var index = state.alerting_contacts.findIndex(function (c) {
            return c.id === contact.id;
        });
        if (index !== -1) state.alerting_contacts.splice(index, 1, contact);
    },
    removeAlertingContact: function removeAlertingContact(state, id) {
        var index = state.alerting_contacts.findIndex(function (c) {
            return c.id === id;
        });
        if (index !== -1) state.alerting_contacts.splice(index, 1);
    },
    setLanguage: function setLanguage(state, language) {
        state.language = language;
        __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.set("lang", language);
    },
    setFirmwareHistory: function setFirmwareHistory(state, list) {
        state.firmware_versions = list;
    },
    addFirmwareHistory: function addFirmwareHistory(state, entry) {
        state.firmware_versions.push(entry);
    }
});

/***/ }),

/***/ "vGaQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        big: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            languages: ['da', 'en']
        };
    },

    computed: {
        size: function size() {
            return this.big ? '32' : '24';
        },
        inactiveLanguages: function inactiveLanguages() {
            var active = this.activeLang;
            return this.languages.filter(function (l) {
                return l != active;
            });
        },
        activeLang: function activeLang() {
            return this.$polyglot.lang;
        }
    },
    methods: {
        flag: function flag(lang) {
            return "/static/icons/language/" + lang + "-" + this.size + ".png";
        },
        setLanguage: function setLanguage(lang) {
            this.$store.dispatch("setLanguage", lang);
        }
    }
});

/***/ }),

/***/ "vkIy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_default_header_vue__ = __webpack_require__("QZsj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_default_footer_vue__ = __webpack_require__("toTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_login_login_vue__ = __webpack_require__("EV1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_default_messages_vue__ = __webpack_require__("TDlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_auth__ = __webpack_require__("TIfe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    components: {
        themeHeader: __WEBPACK_IMPORTED_MODULE_0__components_layout_default_header_vue__["a" /* default */],
        themeFooter: __WEBPACK_IMPORTED_MODULE_1__components_layout_default_footer_vue__["a" /* default */],
        loginPage: __WEBPACK_IMPORTED_MODULE_2__components_login_login_vue__["a" /* default */],
        messageBoxes: __WEBPACK_IMPORTED_MODULE_3__components_layout_default_messages_vue__["a" /* default */]
    },
    computed: {
        isLoggedIn: function isLoggedIn() {
            return this.$store.getters.isAuthenticated;
        }
    },
    created: function created() {
        __WEBPACK_IMPORTED_MODULE_4__utils_auth__["a" /* default */].restore();
    }
});

/***/ }),

/***/ "xKc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__("E9Zr");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.22b3cec6a247689f0a0e.js